<template>
    
    <spinner v-if="!loaded" ></spinner>

    <div class="analyze-page" v-else-if="loaded" > 
        
        <!-- OVERVIEW -->
        <div class="mt-5 row no-gutters" v-if="contentType == 'overview'" >
            
            <div class="col-12 col-md-8 pr-md-2 " >

                <div class="p-4 border-gray border-radius bg-color-graylight Text-color--black" >

                    <div class="row ml-0 mr-0 d-none" >
                        <div class="col col-md-6" >
                            <span class="h3 font-900" style="" > Sales  </span>
                        </div>

                        <div class="col-auto col-md text-md-right" style=""  >
                            Refresh: <a @click="refresh_chart" class="ml-1"  > <font-awesome-icon icon="sync" /> </a>
                        </div>
                    </div>

                    <div class="row ml-0 mr-0 d-none" >

                        <div class="col-3 border-right-gray" >

                            <span class="h2 font-900" style="" > Sales  </span>

                        </div>

                        <div class="col " >

                            <div class="d-none col-12" >

                                <a @click="switchChart('gross-revenue')" class="" > Revenue </a>
                                <a @click="switchChart('number-of-sales')" > Sales </a>
                                <a @click="switchChart('active-customers')" > Customers </a>

                            </div>

                        </div>

                        <div class="col-auto " >

                            Refresh: <a @click="refresh_chart" class="ml-1"  > <font-awesome-icon icon="sync" /> </a>

                        </div>

                    </div>

                    <div class="row ml-0 mr-0 " >

                        <div class="col-12 col-md-3 p-2 " >

                            <div class="row" >

                                <div class="col-12 p-0 " >
                                    <div class="pt-0 pb-2 pl-4 pr-4 " >
                                        <h1 class="h3 font-900 d-inline-block w-auto" > 
                                            Sales 
                                            
                                        </h1>
                                        <span class="float-right d-block d-md-none font-size-14" >
                                                Refresh: <a @click="refresh_chart" class="ml-1 font-size-14"  > <font-awesome-icon icon="sync" /> </a>
                                            </span>
                                    </div>
                                </div>

                                <div class="col-6 col-md-12 mt-2 p-2 p-md-1 text-center text-md-left " >
                                    <div class="p-0 p-md-3" >
                                        <h1 class="" v-if="SOURCES[0].orders.length == 0" > - </h1>
                                        <h1 class="h2 font-weight-bold" v-else-if="SOURCES[0].orders.length > 0" > 
                                            {{ return_revenue_column( SOURCES[0] ) }}
                                        </h1>
                                        <p class="font-size-1 font-weight-bold text-uppercase Text-color--graylmedium" > Revenue </p>
                                    </div>
                                </div>

                                <div class="col-6 col-md-12 mt-2 mt-md-3 p-2 p-md-1 text-center text-md-left " >
                                    <div class="p-0 p-md-3" >
                                        <h1 class="" v-if="SOURCES[0].orders.length == 0" > - </h1>
                                        <h1 class="h2" v-else-if="SOURCES[0].orders.length > 0" > 
                                            <span v-html="return_PROFIT_column( SOURCES[0] )"></span>
                                        </h1>
                                        <p class="font-size-16 font-weight-bold text-uppercase Text-color--graylmedium" > Profit </p>
                                    </div>
                                </div>

                            </div>

                        </div>

                        <div class="col-12 col-md-9 p-0" >

                            <div class="col-12 mt-1 ml-0 ml-md-4" >

                                <div class="row" >
                                    <div class="col col-md-auto p-0" >
                                        <a @click="switchChart('gross-revenue')" class="mr-3 p-0 d-block font-weight-bold text-uppercase Text-color--graylmedium text-decoration-none text-center text-md-left" :class="(( selectedChart == 'gross-revenue' ) ? 'active border-bottom-main' : '' )"  > Revenue </a>
                                    </div>
                                    <div class="col col-md-auto p-0" >
                                        <a @click="switchChart('number-of-sales')" class="mr-3 p-0 d-block font-weight-bold text-uppercase Text-color--graylmedium text-decoration-none text-center text-md-left" :class="(( selectedChart == 'number-of-sales' ) ? 'active border-bottom-main' : '' )"  > Sales </a>
                                    </div>
                                    <div class="col col-md-auto p-0" >
                                        <a @click="switchChart('active-customers')" class="mr-3 p-0 d-block font-weight-bold text-uppercase Text-color--graylmedium text-decoration-none text-center text-md-left" :class="(( selectedChart == 'active-customers' ) ? 'active border-bottom-main' : '' )"  > Customers </a>
                                    </div>
                                    <div class="col p-0 mr-4 d-none d-md-block text-md-right" >
                                        Refresh: <a @click="refresh_chart" class="ml-1"  > <font-awesome-icon icon="sync" /> </a>
                                    </div>
                                </div>

                            </div>

                            <div class="m-0 mt-md-4 ml-md-4 mr-md-4" v-if="selectedChart == 'gross-revenue'" >
                                <spinner v-if="!dataLoaded" ></spinner>
                                <chartBlock :data="rows" CHART="gross-revenue" :startDate="startDate" :endDate="endDate" symbol='$' v-else-if="dataLoaded" :HEIGHT="200" CHART_COMPONENT="full" ></chartBlock>
                            </div>

                            <div class="m-0 mt-md-4 ml-md-4 mr-md-4" v-if="selectedChart == 'number-of-sales'" >
                                <spinner v-if="!dataLoaded" ></spinner>
                                <chartBlock :data="rows" CHART="number-of-sales" :startDate="startDate" :endDate="endDate"  v-else-if="dataLoaded" :HEIGHT="200" CHART_COMPONENT="full" ></chartBlock>
                            </div>

                            <div class="m-0 mt-md-4 ml-md-4 mr-md-4" v-if="selectedChart == 'active-customers'" >
                                <spinner v-if="!dataLoaded" ></spinner>
                                <chartBlock :data="rows" CHART="active-customers" :startDate="startDate" :endDate="endDate"  v-else-if="dataLoaded" :HEIGHT="200" CHART_COMPONENT="full" ></chartBlock>
                            </div>

                        </div>

                    </div>

                    <div class="row ml-0 mr-0 mt-3 pt-3 border-top-gray flex-wrap-scroll" >

                        <div class="col-5 col-md p-3 border-right-gray text-right" >
                            <div class=" pt-2 pb-2 pl-4 pr-4 " >
                                <h1 class="h2" v-if="SOURCES[0].orders.length == 0" > - </h1>
                                <h1 class="h2" v-else-if="SOURCES[0].orders.length > 0" > 
                                    {{ return_adspent_column( SOURCES[0].ad_spent ) }}
                                </h1>
                                <p class="font-size-12 font-weight-bold text-uppercase Text-color--graylmedium" > Ad spent </p>
                            </div>
                        </div>

                        <div class="col-5 col-md p-3 border-right-gray text-right" >
                            <div class=" pt-2 pb-2 pl-4 pr-4 " >
                                <h1 class="h2" v-if="SOURCES[0].orders.length == 0" > - </h1>
                                <h1 class="h2" v-else-if="SOURCES[0].orders.length > 0" > 
                                    {{ SOURCES[0].orders.length }}
                                </h1>
                                <p class="font-size-12 font-weight-bold text-uppercase Text-color--graylmedium" > Sales </p>
                            </div>
                        </div>

                        <div class="col-5 col-md p-3 border-right-gray text-right" >
                            <div class=" pt-2 pb-2 pl-4 pr-4 " >
                                <h1 class="h2" v-if="SOURCES[0].orders.length == 0" > - </h1>
                                <h1 class="h2" v-else-if="SOURCES[0].orders.length > 0" > 
                                    {{ uniqueItemsInArray(SOURCES[0].orders, 'leadID' ) }}
                                </h1>
                                <p class="font-size-12 font-weight-bold text-uppercase Text-color--graylmedium" > 
                                    Customers 
                                    <span class=""  > 
                                        <font-awesome-icon :icon="['fa', 'question-circle']" :id="`tooltip--info-customers`" style="margin-top: -4px;" />  
                                        <b-tooltip :target="`tooltip--info-customers`" placement="right" triggers="hover" custom-class="" >
                                            <span  > Unique customers that made a purchase </span>

                                            <div class="mt-2" > Read more on how we calculate all stats <a :href="resourcesLink( 'blog/metrics-explained/' )" class="cursor-pointer Text-color--white"  target="_blank" > here </a> </div>
                                        </b-tooltip>
                                    </span>
                                </p>
                            </div>
                        </div>

                        <div class="col-5 col-md p-3 border-right-gray text-right" >
                            <div class=" pt-2 pb-2 pl-4 pr-4 " >
                                <h1 class="h2" v-if="SOURCES[0].orders.length == 0" > - </h1>
                                <h1 class="h2" v-else-if="SOURCES[0].orders.length > 0" > 
                                    {{ Numberformatter( ( SOURCES[0].revenue / SOURCES[0].orders.length ).toFixed(2), 'number' ) }}
                                </h1>
                                <p class="font-size-12 font-weight-bold text-uppercase Text-color--graylmedium" >
                                    AOV
                                    <span class=""  > 
                                        <font-awesome-icon :icon="['fa', 'question-circle']" :id="`tooltip--info-apv`" style="margin-top: -4px;" />  
                                        <b-tooltip :target="`tooltip--info-apv`" placement="right" triggers="hover" custom-class="" >
                                            <span  > Average Order Value </span>

                                            <div class="mt-2" > Read more on how we calculate all stats <a :href="resourcesLink( 'blog/metrics-explained/' )" class="cursor-pointer Text-color--white"  target="_blank" > here </a> </div>
                                        </b-tooltip>
                                    </span>
                                </p>
                            </div>
                        </div>

                        <div class="col-5 col-md p-3 text-right" >
                            <div class=" pt-2 pb-2 pl-4 pr-4 " >
                                <h1 class="h2" v-if="SOURCES[0].orders.length == 0" > - </h1>
                                <h1 class="h2" v-else-if="SOURCES[0].orders.length > 0" > 
                                    {{ Numberformatter( ( SOURCES[0].revenue / uniqueItemsInArray(SOURCES[0].orders, 'leadID' ) ).toFixed(2), 'number' ) }}
                                </h1>
                                <p class="font-size-12 font-weight-bold text-uppercase Text-color--graylmedium" >
                                    ARPU 
                                    <span class=""  > 
                                        <font-awesome-icon :icon="['fa', 'question-circle']" :id="`tooltip--info-arpu`" style="margin-top: -4px;" />  
                                        <b-tooltip :target="`tooltip--info-arpu`" placement="right" triggers="hover" custom-class="" >
                                            <span  > Average Revenue Per User ( Customer ) </span>

                                            <div class="mt-2" > Read more on how we calculate all stats <a :href="resourcesLink( 'blog/metrics-explained/' )" target="_blank"  class="cursor-pointer Text-color--white" > here </a> </div>
                                        </b-tooltip>
                                    </span>
                                </p>
                            </div>
                        </div>

                        <div class="col-5 col-md p-3 text-right d-none" >
                            <div class=" pt-2 pb-2 pl-4 pr-4 " >
                                <h1 class="h2" v-if="LTV.LTV == 0 || LTV.LTV == '-' " > - </h1>
                                <h1 class="h2" v-else-if="LTV.LTV > 0" > 
                                    {{ Numberformatter( LTV.LTV, 'number' ) }}
                                </h1>
                                <p class="font-size-12 font-weight-bold text-uppercase Text-color--graylmedium" >
                                    
                                    LTV
                                    <span class=""  > 
                                        <font-awesome-icon :icon="['fa', 'question-circle']" :id="`tooltip--info-ltv`" style="margin-top: -4px;" />  
                                        <b-tooltip :target="`tooltip--info-ltv`" placement="right" triggers="hover" custom-class="" >
                                            <span  > Customer Lifetime Value </span>

                                            <div class="mt-2" > Read more on how we calculate all stats <a :href="resourcesLink( 'blog/metrics-explained/' )" target="_blank" class="cursor-pointer Text-color--white" > here </a> </div>
                                        </b-tooltip>
                                    </span>
                                    
                                </p>
                            </div>
                        </div>

                    </div>

                </div>

            </div>
            
            <div class="col-12 col-md-4 pl-md-2 mt-3 mt-md-0" >
                <div class="border-gray p-4 border-radius h-100" >
                    
                    <div class="col-12 p-0" >
                        
                        <spinner v-if="!dataLoaded" ></spinner>
                        <chartBlockPie :data="filteredSources" CHART="pie" :HEIGHT="380" TITLE="Attribution" v-else-if="dataLoaded" CHART_COMPONENT="full" ></chartBlockPie>
                        
                    </div>
                    
                </div>
            </div>
            
        </div>
        <!-- OVERVIEW -->
        
        <!-- FULL -->
        <div v-if="contentType == 'full'" >
        
        <div class="row no-gutters mb-4 mt-3" v-if="contentType == 'full'" >
            
            <div class="col-12 col-md-auto" >
                <span class="h3 font-900" style="line-height: 34px; margin-rigth: 15px" > Select dates:  </span>

                <date-picker v-model="period" range valueType="format" :format="formatDate" confirm class="datepicker ml-2" @change="refresh_chart" clear-button-icon="false" :shortcuts="shortcuts" ></date-picker>
            </div>
            
            <div class="col-12 col-md-auto text-md-right mt-2 mt-md-0 pl-md-3 pr-md-3" style="line-height: 34px;"  >
                
                <span class="mr-1 ml-1" > 
                    <span class="font-size-16" > <font-awesome-icon :icon="['fa', 'question-circle']" :id="`tooltip--info-empty-sources`"  />  </span>
                    <b-tooltip :target="`tooltip--info-empty-sources`" placement="right" triggers="hover" custom-class="tooltip-narrow" >
                        Sources that haven't made any conversions are hidden by default.
                    </b-tooltip>
                </span>
                <span v-if="showEmpty" > Hide empty sources </span>
                <span v-else-if="!showEmpty" > Show empty sources </span>
                <b-form-checkbox v-model="showEmpty" name="check-button" class="cursor-pointer d-inline-block" switch > </b-form-checkbox>
                                
            </div>
            
            <div class="col-12 col-md-auto text-md-right" style=""  >
                Attribution: 

                <multiselect v-model="selectedAttribution" deselect-label=" " select-label=" " track-by="value" label="text" placeholder="Switch attribution" :options="atributionOptions" @input="switchAttribution" class="d-inline-block w-auto multieselect-attribution" :allow-empty="false" >
                </multiselect>
                
                <span class="mr-1 ml-2" > 
                    <a :href="resourcesLink( 'docs/learn-about-attribution-models' )" target="_blank" > 
                        <span class="font-size-16" > <font-awesome-icon :icon="['fa', 'question-circle']" :id="`tooltip--info-attribution-info`"  /> </span>
                        <b-tooltip :target="`tooltip--info-attribution-info`" placement="left" triggers="hover" custom-class="tooltip-narrow" >
                            Tracked data is attributed to sources using different attribution models. Click to read more about them.
                        </b-tooltip>
                    </a>
                </span>
                
            </div>
            
        </div>
            
        <div class="row pl-3 pr-3" >
            
            <div class="col-6 col-md-auto p-1 flex-wrap-scroll" >
                <div class="border-main border-radius pt-3 pb-3 pl-4 pr-4 bg-white" >
                    <h1 class="h2" > {{ return_adspent_column( SOURCES[0].ad_spent ) }} </h1>
                    <p class="font-size-12 font-weight-bold text-uppercase Text-color--graylmedium" > AD SPENT </p>
                </div>
            </div>
            
            <div class="col-6 col-md-auto p-1 d-none" >
                <div class="border-main border-radius pt-3 pb-3 pl-4 pr-4 bg-white" >
                    <h1 class="h2 Text-color-main" > {{ SOURCES[0].orders.length }} </h1>
                    <p class="font-size-12 font-weight-bold text-uppercase Text-color--graylmedium" > SALES </p>
                </div>
            </div>
            
            <div class="col-6 col-md-auto p-1 d-none" >
                <div class="border-main border-radius pt-3 pb-3 pl-4 pr-4 bg-white" >
                    <h1 class="h2 Text-color-main" > {{ return_revenue_column( SOURCES[0] ) }} </h1>
                    <p class="font-size-12 font-weight-bold text-uppercase Text-color--graylmedium" > REVENUE </p>
                </div>
            </div>
            
            <div class="col-6 col-md-auto p-1" >
                <div class="border-main border-radius pt-3 pb-3 pl-4 pr-4 bg-white" >
                    <h1 class="h2 Text-color-main" > <span v-html="return_PROFIT_column( SOURCES[0] )"></span> </h1>
                    <p class="font-size-12 font-weight-bold text-uppercase Text-color--graylmedium" > PROFIT </p>
                </div>
            </div>
            
            <div class="col-6 col-md-auto p-1" >
                <div class="border-main border-radius pt-3 pb-3 pl-4 pr-4 bg-white" >
                    <h1 class="h2 Text-color-main" > <span v-html="return_ROAS_column( SOURCES[0] )"></span> </h1>
                    <p class="font-size-12 font-weight-bold text-uppercase Text-color--graylmedium" > ROAS </p>
                </div>
            </div>
            
            <div class="col-6 col-md-auto p-1" >
                <div class="border-main border-radius pt-3 pb-3 pl-4 pr-4 bg-white" >
                    <h1 class="h2 Text-color-main" > <span v-html="return_AVG_QUANTITY_column( SOURCES[0] )"></span> </h1>
                    <p class="font-size-12 font-weight-bold text-uppercase Text-color--graylmedium" > 
                        CARDINALITY
                        <span class=""  > 
                            <font-awesome-icon :icon="['fa', 'question-circle']" :id="`tooltip--info-cardinality`" style="margin-top: -4px;" />  
                            <b-tooltip :target="`tooltip--info-cardinality`" placement="right" triggers="hover" custom-class="" >
                                <span  > Product Cardinality </span>
                                
                                

                                <div class="mt-2" > Read more on how we calculate all stats <a :href="resourcesLink( 'blog/metrics-explained/' )" class="cursor-pointer Text-color--white"  target="_blank" > here </a> </div>
                            </b-tooltip>
                        </span>
                    </p>
                </div>
            </div>
            
            <div class="col-6 col-md-auto p-1" >
                <div class="border-main border-radius pt-3 pb-3 pl-4 pr-4 bg-white" >
                    <h1 class="h2 Text-color-main" v-if="LTV.AVG_PURCHASE_VALUE && LTV.AVG_PURCHASE_VALUE != '-'" > {{ Numberformatter( LTV.AVG_PURCHASE_VALUE, 'number' ) }} </h1>
                    <h1 class="h2 Text-color-main" v-else-if="LTV.AVG_PURCHASE_VALUE == '-'" > {{ LTV.AVG_PURCHASE_VALUE }} </h1>
                    <p class="font-size-12 font-weight-bold text-uppercase Text-color--graylmedium" > 
                        AOV
                        <span class=""  > 
                            <font-awesome-icon :icon="['fa', 'question-circle']" :id="`tooltip--info-apv`" style="margin-top: -4px;" />  
                            <b-tooltip :target="`tooltip--info-apv`" placement="right" triggers="hover" custom-class="" >
                                <span  > Average Order Value </span>
                                
                                <div class="mt-2" > Make sure to select a period of at least 14 days </div>

                                <div class="mt-2" > Read more on how we calculate all stats <a :href="resourcesLink( 'blog/metrics-explained/' )" class="cursor-pointer Text-color--white"  target="_blank" > here </a> </div>
                            </b-tooltip>
                        </span>
                    </p>
                </div>
            </div>
            
            <div class="col-6 col-md-auto p-1" >
                <div class="border-main border-radius pt-3 pb-3 pl-4 pr-4 bg-white" >
                    <h1 class="h2 Text-color-main" v-if="LTV.CUSTOMER_VALUE && LTV.CUSTOMER_VALUE != '-'" > {{ Numberformatter( LTV.CUSTOMER_VALUE, 'number' ) }} </h1>
                    <h1 class="h2 Text-color-main" v-else-if="LTV.CUSTOMER_VALUE == '-'" > {{ LTV.CUSTOMER_VALUE }} </h1>
                    <p class="font-size-12 font-weight-bold text-uppercase Text-color--graylmedium" > 
                        ARPU 
                        <span class=""  > 
                            <font-awesome-icon :icon="['fa', 'question-circle']" :id="`tooltip--info-arpu`" style="margin-top: -4px;" />  
                            <b-tooltip :target="`tooltip--info-arpu`" placement="right" triggers="hover" custom-class="" >
                                <span  > Average Revenue Per User ( Customer ) </span>
                                
                                <div class="mt-2" > Make sure to select a period of at least 14 days </div>

                                <div class="mt-2" > Read more on how we calculate all stats <a :href="resourcesLink( 'blog/metrics-explained/' )" target="_blank"  class="cursor-pointer Text-color--white" > here </a> </div>
                            </b-tooltip>
                        </span>
                    </p>
                </div>
            </div>
            
            <div class="col-6 col-md-auto p-1" >
                <div class="border-main border-radius pt-3 pb-3 pl-4 pr-4 bg-white" >
                    <h1 class="h2 Text-color-main" v-if="LTV.LTV && LTV.LTV != '-'" > {{ Numberformatter( LTV.LTV, 'number' ) }} </h1>
                    <h1 class="h2 Text-color-main" v-else-if="LTV.LTV == '-'" > {{ LTV.LTV }} </h1>
                    <p class="font-size-12 font-weight-bold text-uppercase Text-color--graylmedium" > 
                        LTV
                        <span class=""  > 
                            <font-awesome-icon :icon="['fa', 'question-circle']" :id="`tooltip--info-ltv`" style="margin-top: -4px;" />  
                            <b-tooltip :target="`tooltip--info-ltv`" placement="right" triggers="hover" custom-class="" >
                                <span  > Customer Lifetime Value </span>

                                <div class="mt-2" > Make sure to select a period of at least 14 days </div>

                                <div class="mt-2" > Read more on how we calculate all stats <a :href="resourcesLink( 'blog/metrics-explained/' )" target="_blank" class="cursor-pointer Text-color--white" > here </a> </div>
                                
                            </b-tooltip>
                        </span>
                    </p>
                </div>
            </div>
            
        </div>
        
        <!-- CHART SECTION -->
        <div class="row atlass-grid no-gutters mt-3" >
            <div class="col-12 col-md-4" >
                <spinner v-if="!dataLoaded" ></spinner>
                <chartBlock :data="rows" CHART="gross-revenue" TITLE="Revenue" :startDate="startDate" :endDate="endDate" symbol='$' v-else-if="dataLoaded" :HEIGHT="120" CHART_COMPONENT="full" ></chartBlock>
            </div>
            <div class="col-12 col-md-4" >
                <spinner v-if="!dataLoaded" ></spinner>
                <chartBlock :data="rows" CHART="number-of-sales" TITLE="Purchases" :startDate="startDate" :endDate="endDate" v-else-if="dataLoaded" :HEIGHT="120" CHART_COMPONENT="full" > </chartBlock>
            </div>
            
            <div class="col-12 col-md-4" >
                <spinner v-if="!dataLoaded" ></spinner>
                <chartBlock :data="rows" CHART="active-customers" TITLE="Active customers" :startDate="startDate" :endDate="endDate" v-else-if="dataLoaded" :HEIGHT="120" CHART_COMPONENT="full" > </chartBlock>
            </div>
            
        </div>
        <!-- CHART SECTION -->
        
        <spinner v-if="!dataLoaded" ></spinner>
        <div class="row  mt-4" v-else-if="dataLoaded" >
            <!-- FILTER RESULTS -->
            <div class="row col-12 font-size-14 mr-0 ml-0 " v-if="contentType == 'full'" >
                
                <div class="col-12 col-md-auto mt-1 mb-1 p-0 p-md-1" >
                    
                    <span class="h5 font-900 d-inline" style="line-height: 34px; margin-rigth: 15px" > Filter results by:  </span>
                    
                </div>
                
                <div class="col-12 col-md-2 mt-1 mb-1 p-0 p-md-1" >
                    
                    <span class="h3 font-900 d-none" style="line-height: 34px; margin-rigth: 15px" > Filter by origin:  </span>
                    <multiselect v-model="selected_sourcesOrigin" deselect-label=" " select-label=" " track-by="value" label="text" placeholder="Filter by origin:" :options="sourcesOrigin" @input="parseFilteredConversions" class="d-inline-block w-100" >
                    </multiselect>
                    
                </div>
                
                <div class="col-12 col-md-2 mt-1 mb-1 p-0 p-md-1" >
                    
                    <span class="h3 font-900 d-none" style="line-height: 34px; margin-rigth: 15px" > Filter by Module:  </span>
                    <multiselect v-model="selectedModules" :multiple="true" deselect-label=" " select-label=" " track-by="value" label="text" placeholder="Filter by module:" :options="filterModules" @input="parseFilteredConversions" class="d-inline-block w-100" >
                    </multiselect>
                    
                </div>
                
                <div class="col-12 col-md mt-1 mb-1 p-0 p-md-1" >
                    
                    <span class="h3 font-900 d-none" style="line-height: 34px; margin-rigth: 15px" > Filter by tags:  </span>
                    <multiselect v-model="selectedTags" :options="filterTags" :multiple="true" :preserve-search="true" deselect-label=" " select-label=" " track-by="value" label="text" placeholder="Filter by tags"  @input="parseFilteredConversions" class="d-inline-block w-100" >
                    </multiselect>
                    
                </div>
                
            </div>
            <!-- FILTER RESULTS -->
            <!-- GROUP RESULTS -->
            <div class="row col-12 font-size-14 mr-0 ml-0 " >
                
                <div class="col-12 col-md-auto mt-1 mb-1 p-0 p-md-1" >
                    
                    <span class="h5 font-900 d-inline" style="line-height: 34px; margin-rigth: 15px" > Group results by:  </span>
                    
                </div>
                
                <div class="col-12 col-md mt-1 mb-1 p-0 p-md-1" >
                    
                    <!-- 
                    <multiselect v-model="groupBy" :options="groupResults" deselect-label=" " select-label=" " track-by="value" label="text" placeholder="Group results by:"  @input="SORT_SOURCES" class="d-inline-block w-100" >
                    </multiselect>
                    -->
                    
                    <div class="row no-gutters flex-wrap-scroll" >
                        <div class="col-auto pl-3 pr-3 btn-transparent text-center mr-2 cursor-pointer" v-for="(group, index) in groupResults" @click="groupBy = group; SORT_SOURCES();" v-bind:class="{ 'active' : group.value == groupBy.value }" > {{ group.text }} </div>
                    </div>
                    
                </div>
                
            </div>
            <!-- GROUP RESULTS -->
            
            <div class="col-12 mt-2" >
                
                <vue-good-table
                    class="analyze-table"
                    :columns="sourceColumns"
                    :rows="filteredSources"
                    styleClass="vgt-table atlass-datatable mt-0"
                    :search-options="{ enabled: true, externalQuery: filter }"
                    :pagination-options="{ 
                        enabled: true,
                        perPage: itemsPerPage,
                        perPageDropdown: [50, 100],
                        ropdownAllowAll: true,
                        nextLabel: 'next',
                        prevLabel: 'prev',
                        rowsPerPageLabel: 'Sources per page',
                        ofLabel: 'of',
                        pageLabel: 'page', // for 'pages' mode
                        allLabel: 'All',
                    }"
                    :selectOptions="{
                        enabled: false,
                        selectOnCheckboxOnly: false, // only select when checkbox is clicked instead of the row
                        selectionInfoClass: 'custom-class',
                        selectionText: 'rows selected',
                        clearSelectionText: 'clear',
                      }"
                    @on-row-click="openCampaign"
                     >

                    <template slot="table-row" slot-scope="props">
                        
                        <span v-if="props.column.field == 'origin'">
                            <span class="tablecell-icon" v-if="props.row.origin == 'ATLASS' " > <img src="@/assets/icons/atlass.svg" /> </span>
                            
                            <span class="tablecell-icon" v-if="props.row.origin == 'FACEBOOK'" > 
                                
                                <img src="@/assets/icons/facebook.png" :id="`tooltip--fb${props.row.account_name}-${props.row.external_id}`" /> 
                                <b-tooltip :target="`tooltip--fb${props.row.account_name}-${props.row.external_id}`" placement="right" triggers="hover" v-if="props.row.stats"  >                                    
                                     Reported stats from Facebook: 
                                    <br> Account: <b> {{props.row.account_name}} ( ID: {{ props.row.account_id }} ) </b>
                                    <span v-if="props.row.campaign" > <br> Campaign: <b> {{props.row.campaign.name}} ( {{props.row.campaign.id}} ) </b> </span>
                                    <span v-if="props.row.adset" > <br> Ad Set: <b> {{props.row.adset.name}} ( {{props.row.adset.id}} )  </b> </span>
                                    <span v-if="props.row.adset && props.row.campaign" > <br> Ad Name: <b> {{props.row.name}} ( {{props.row.external_id}} ) </b> </span>
                                                                        
                                    <br> Impressions: <b> {{props.row.impressions}} </b>
                                    <br> Clicks: <b> {{props.row.clicks}} </b>
                                    <br> Ad spent: <b> {{ Numberformatter( props.row.ad_spent, 'number' ) }} </b>
                                    <br> Reported revenue: <b> {{ Numberformatter( props.row.reported_conversion_value, 'number' ) }} </b>
                                    <br> Reported conversions: <b> {{props.row.reported_conversions}} </b>
                                </b-tooltip>
                            </span>
                            
                            <span class="tablecell-icon" v-if="props.row.origin == 'TIKTOK'" > 
                                
                                <img src="@/assets/icons/tiktok.png" :id="`tooltip--fb${props.row.account_name}-${props.row.external_id}`" /> 
                                <b-tooltip :target="`tooltip--fb${props.row.account_name}-${props.row.external_id}`" placement="right" triggers="hover" v-if="props.row.stats"  >                                    
                                     Reported stats from TikTok: 
                                    <br> Account: <b> {{props.row.account_name}} ( ID: {{ props.row.account_id }} ) </b>
                                    <span v-if="props.row.campaign" > <br> Campaign: <b> {{props.row.campaign.name}} ( {{props.row.campaign.id}} ) </b> </span>
                                     <span v-if="props.row.adset" > <br> Ad Set: <b> {{props.row.adset.name}} ( {{props.row.adset.id}} )  </b> </span>
                                    <span v-if="props.row.adset && props.row.campaign" > <br> Ad Name: <b> {{props.row.account_name}} ( {{props.row.external_id}} ) </b> </span>
                                                                        
                                    <br> Impressions: <b> {{props.row.impressions}} </b>
                                    <br> Clicks: <b> {{props.row.clicks}} </b>
                                    <br> Ad spent: <b> {{ Numberformatter( props.row.ad_spent, 'number' ) }} </b>
                                    <br> Reported revenue: <b> {{ Numberformatter( props.row.reported_conversion_value, 'number' ) }} </b>
                                    <br> Reported conversions: <b> {{props.row.reported_conversions}} </b>
                                </b-tooltip>
                            </span>
                            
                            <span class="tablecell-icon" v-if="props.row.origin == 'GOOGLE'" > 
                                
                                <img src="@/assets/icons/googleadwords.png" :id="`tooltip--fb${props.row.account_name}-${props.row.external_id}`" /> 
                                <b-tooltip :target="`tooltip--fb${props.row.account_name}-${props.row.external_id}`" placement="right" triggers="hover" v-if="props.row.stats"  >                                    
                                     Reported stats from Google: 
                                    <br> Account: <b> {{props.row.account_name}} ( ID: {{ props.row.account_id }} ) </b>
                                    <span v-if="props.row.campaign" > <br> Campaign: <b> {{props.row.campaign.name}} ( {{props.row.campaign.id}} ) </b> </span>
                                    <span v-if="props.row.adset" > <br> Ad Set: <b> {{props.row.adset.name}} ( {{props.row.adset.id}} )  </b> </span>
                                    <span v-if="props.row.adset && props.row.campaign" > <br> Ad Name: <b> {{props.row.name}} ( {{props.row.external_id}} ) </b> </span>
                                    <br> Impressions: <b> {{props.row.impressions}} </b>
                                    <br> Clicks: <b> {{props.row.clicks}} </b>
                                    <br> Ad spent: <b> {{ Numberformatter( props.row.ad_spent, 'number' ) }} </b>
                                    <br> Reported revenue: <b> {{ Numberformatter( props.row.reported_conversion_value, 'number' ) }} </b>
                                    <br> Reported conversions: <b> {{props.row.reported_conversions}} </b>
                                </b-tooltip>
                            </span>
                            
                            <span class="tablecell-icon" v-if="props.row.origin == 'MAILCHIMP'" > 
                                
                                <font-awesome-icon :icon="['fab', 'mailchimp']"  :id="`tooltip--mc-${props.row.external_id}`"  /> 
                                <b-tooltip :target="`tooltip--mc-${props.row.external_id}`" placement="right" triggers="hover" v-if="props.row.stats"  >
                                    Reported stats from Mailchimp: 
                                    Emais sent: <b> {{props.row.stats.emails_sent}} </b>
                                    Unique Opens: <b> {{props.row.stats.unique_opens}} </b>
                                    Unique Clicks: <b> {{props.row.stats.subscriber_clicks}} </b>
                                    
                                    
                                </b-tooltip>
                            </span>
                            
                            <span class="tablecell-icon" v-if="props.row.origin == 'ACTIVECAMPAIGN'" > 
                                
                                <img src="@/assets/icons/activecampaign.png" :id="`tooltip--ac-${props.row.tag}-${props.row.external_id}`" />
                                <b-tooltip :target="`tooltip--ac-${props.row.tag}-${props.row.external_id}`" placement="right" triggers="hover" v-if="props.row.stats"  >
                                    Reported stats from Active Campaign: 
                                    Emais sent: <b>  </b>
                                    Unique Opens: <b> {{props.row.stats.uniqueopens}} </b>
                                    Unique Clicks: <b> {{props.row.stats.uniquelinkclicks}} </b>
                                </b-tooltip>
                            </span>

                        </span>
                        
                        <span v-else-if="props.column.field == 'name'" >
                            
                            <span class="tablecell-icon" v-if="props.row.origin == 'ATLASS_DEFAULT' " > <img src="@/assets/icons/atlass.svg" style="visibility: hidden;" /> </span>
                            <span class="tablecell-icon" v-if="props.row.origin == 'ATLASS' " > <img src="@/assets/icons/atlass.svg" /> </span>
                            
                            <span class="tablecell-icon" v-if="props.row.origin == 'FACEBOOK'" > 
                                
                                <img src="@/assets/icons/facebook.png" :id="`tooltip--fb${props.row.account_name}-${props.row.external_id}`" /> 
                                <b-tooltip :target="`tooltip--fb${props.row.account_name}-${props.row.external_id}`" placement="right" triggers="hover" v-if="props.row.stats"  >                                    
                                     Reported stats from Facebook: 
                                    <br> Account: <b> {{props.row.account_name}} ( ID: {{ props.row.account_id }} ) </b>
                                    <span v-if="props.row.campaign" > <br> Campaign: <b> {{props.row.campaign.name}} ( {{props.row.campaign.id}} ) </b> </span>
                                    <span v-if="props.row.adset" > <br> Ad Set: <b> {{props.row.adset.name}} ( {{props.row.adset.id}} )  </b> </span>
                                    <span v-if="props.row.adset && props.row.campaign" > <br> Ad Name: <b> {{props.row.name}} ( {{props.row.external_id}} ) </b> </span>
                                                                        
                                    <br> Impressions: <b> {{props.row.impressions}} </b>
                                    <br> Clicks: <b> {{props.row.clicks}} </b>
                                    <br> Ad spent: <b> {{ Numberformatter( props.row.ad_spent, 'number' ) }} </b>
                                    <br> Reported revenue: <b> {{ Numberformatter( props.row.reported_conversion_value, 'number' ) }} </b>
                                    <br> Reported conversions: <b> {{props.row.reported_conversions}} </b>
                                </b-tooltip>
                            </span>
                            
                            <span class="tablecell-icon" v-if="props.row.origin == 'TIKTOK'" > 
                                
                                <img src="@/assets/icons/tiktok.png" :id="`tooltip--fb${props.row.account_name}-${props.row.external_id}`" /> 
                                <b-tooltip :target="`tooltip--fb${props.row.account_name}-${props.row.external_id}`" placement="right" triggers="hover" v-if="props.row.stats"  >                                    
                                     Reported stats from TikTok: 
                                    <br> Account: <b> {{props.row.account_name}} ( ID: {{ props.row.account_id }} ) </b>
                                    <span v-if="props.row.campaign" > <br> Campaign: <b> {{props.row.campaign.name}} ( {{props.row.campaign.id}} ) </b> </span>
                                     <span v-if="props.row.adset" > <br> Ad Set: <b> {{props.row.adset.name}} ( {{props.row.adset.id}} )  </b> </span>
                                    <span v-if="props.row.adset && props.row.campaign" > <br> Ad Name: <b> {{props.row.account_name}} ( {{props.row.external_id}} ) </b> </span>
                                                                        
                                    <br> Impressions: <b> {{props.row.impressions}} </b>
                                    <br> Clicks: <b> {{props.row.clicks}} </b>
                                    <br> Ad spent: <b> {{ Numberformatter( props.row.ad_spent, 'number' ) }} </b>
                                    <br> Reported revenue: <b> {{ Numberformatter( props.row.reported_conversion_value, 'number' ) }} </b>
                                    <br> Reported conversions: <b> {{props.row.reported_conversions}} </b>
                                </b-tooltip>
                            </span>
                            
                            <span class="tablecell-icon" v-if="props.row.origin == 'GOOGLE'" > 
                                
                                <img src="@/assets/icons/googleadwords.png" :id="`tooltip--fb${props.row.account_name}-${props.row.external_id}`" /> 
                                <b-tooltip :target="`tooltip--fb${props.row.account_name}-${props.row.external_id}`" placement="right" triggers="hover" v-if="props.row.stats"  >                                    
                                     Reported stats from Google: 
                                    <br> Account: <b> {{props.row.account_name}} ( ID: {{ props.row.account_id }} ) </b>
                                    <span v-if="props.row.campaign" > <br> Campaign: <b> {{props.row.campaign.name}} ( {{props.row.campaign.id}} ) </b> </span>
                                    <span v-if="props.row.adset" > <br> Ad Set: <b> {{props.row.adset.name}} ( {{props.row.adset.id}} )  </b> </span>
                                    <span v-if="props.row.adset && props.row.campaign" > <br> Ad Name: <b> {{props.row.name}} ( {{props.row.external_id}} ) </b> </span>
                                    <br> Impressions: <b> {{props.row.impressions}} </b>
                                    <br> Clicks: <b> {{props.row.clicks}} </b>
                                    <br> Ad spent: <b> {{ Numberformatter( props.row.ad_spent, 'number' ) }} </b>
                                    <br> Reported revenue: <b> {{ Numberformatter( props.row.reported_conversion_value, 'number' ) }} </b>
                                    <br> Reported conversions: <b> {{props.row.reported_conversions}} </b>
                                </b-tooltip>
                            </span>
                            
                            <span class="tablecell-icon" v-if="props.row.origin == 'MAILCHIMP'" > 
                                
                                <font-awesome-icon :icon="['fab', 'mailchimp']"  :id="`tooltip--mc-${props.row.external_id}`"  /> 
                                <b-tooltip :target="`tooltip--mc-${props.row.external_id}`" placement="right" triggers="hover" v-if="props.row.stats"  >
                                    Reported stats from Mailchimp: 
                                    Emais sent: <b> {{props.row.stats.emails_sent}} </b>
                                    Unique Opens: <b> {{props.row.stats.unique_opens}} </b>
                                    Unique Clicks: <b> {{props.row.stats.subscriber_clicks}} </b>
                                    
                                    
                                </b-tooltip>
                            </span>
                            
                            <span class="tablecell-icon" v-if="props.row.origin == 'ACTIVECAMPAIGN'" > 
                                
                                <img src="@/assets/icons/activecampaign.png" :id="`tooltip--ac-${props.row.tag}-${props.row.external_id}`" />
                                <b-tooltip :target="`tooltip--ac-${props.row.tag}-${props.row.external_id}`" placement="right" triggers="hover" v-if="props.row.stats"  >
                                    Reported stats from Active Campaign: 
                                    Emais sent: <b>  </b>
                                    Unique Opens: <b> {{props.row.stats.uniqueopens}} </b>
                                    Unique Clicks: <b> {{props.row.stats.uniquelinkclicks}} </b>
                                </b-tooltip>
                            </span>
                                                        
                            <b :id="`tooltip--name-${props.row.tag}-${props.row.external_id}`"  > {{ props.row.name }} </b>
                            <font-awesome-icon :icon="['fas', 'at']"  v-if="props.row.tag" class="d-none" />
                            <b-tooltip :target="`tooltip--name-${props.row.tag}-${props.row.external_id}`" placement="bottomleft" triggers="hover"  >
                                Name: <b> {{ props.row.name }} </b> <br>
                                Tag: <b>  {{ props.row.tag }} </b>
                                Origin: <b>  {{ props.row.origin }} </b>
                            </b-tooltip>
                            
                        </span>
                        
                        <span v-else-if="props.column.field == 'revenue'" >
                            {{ Numberformatter( props.row.revenue, 'number' ) }} 
                            <span class="reported-stats-span" v-if="props.row.reported_conversion_value  >= 0" > 
                                 vs {{ Numberformatter( props.row.reported_conversion_value, 'number' ) }} 
                                
                                <font-awesome-icon :icon="['fa', 'question-circle']" :id="`tooltip--revenue-${props.row.tag}-${props.row.external_id}`"  />                                
                                <b-tooltip :target="`tooltip--revenue-${props.row.tag}-${props.row.external_id}`" placement="bottomleft" triggers="hover"  >
                                     Reported stats from {{ props.row.origin }}
                                    <span v-if="props.row.origin == 'FACEBOOK'" >
                                        <br> Account: <b> {{props.row.account_name}} ( ID: {{ props.row.account_id }} ) </b>
                                        <span v-if="props.row.campaign" > <br> Campaign: <b> {{props.row.campaign.name}} ( {{props.row.campaign.id}} ) </b> </span>
                                        <span v-if="props.row.adset" > <br> Ad Set: <b> {{props.row.adset.name}} ( {{props.row.adset.id}} )  </b> </span>
                                        <span v-if="props.row.adset && props.row.campaign" > <br> Ad Name: <b> {{props.row.name}} ( {{props.row.external_id}} ) </b> </span>
                                        <br> Impressions: <b> {{props.row.impressions}} </b>
                                        <br> Clicks: <b> {{props.row.clicks}} </b>
                                        <br> Ad spent: <b> {{ Numberformatter( props.row.ad_spent, 'number' ) }} </b>
                                        <br> Reported revenue: <b> {{ Numberformatter( props.row.reported_conversion_value, 'number' ) }} </b>
                                        <br> Reported conversions: <b> {{props.row.reported_conversions}} </b>
                                    </span>
                                </b-tooltip>
                            </span>
                            
                        </span>
                        
                        <span v-else-if="props.column.field == 'conversions'" >
                            
                            {{ countArray( props.row ) }} 
                            <span class="reported-stats-span" v-if="props.row.reported_conversions >= 0" > 
                                 vs {{ props.row.reported_conversions }} 
                                <font-awesome-icon :icon="['fa', 'question-circle']" :id="`tooltip--conversions-${props.row.tag}-${props.row.external_id}`"  />
                                <b-tooltip :target="`tooltip--conversions-${props.row.tag}-${props.row.external_id}`" placement="bottomleft" triggers="hover"  >
                                    Reported stats from {{ props.row.origin }}
                                    
                                    <span v-if="props.row.origin == 'FACEBOOK'" >
                                        <br> Account: <b> {{props.row.account_name}} ( ID: {{ props.row.account_id }} ) </b>
                                        <span v-if="props.row.campaign" > <br> Campaign: <b> {{props.row.campaign.name}} ( {{props.row.campaign.id}} ) </b> </span>
                                        <span v-if="props.row.adset" > <br> Ad Set: <b> {{props.row.adset.name}} ( {{props.row.adset.id}} )  </b> </span>
                                        <span v-if="props.row.adset && props.row.campaign" > <br> Ad Name: <b> {{props.row.name}} ( {{props.row.external_id}} ) </b> </span>
                                        <br> Impressions: <b> {{props.row.stats.impressions}} </b>
                                        <br> Clicks: <b> {{props.row.clicks}} </b>
                                        <br> Ad spent: <b> {{ Numberformatter( props.row.ad_spent, 'number' ) }} </b>
                                        <br> Reported revenue: <b> {{ Numberformatter( props.row.reported_conversion_value, 'number' ) }} </b>
                                        <br> Reported conversions: <b> {{props.row.reported_conversions}} </b>
                                    </span>
                                    
                                </b-tooltip>
                            </span>
                            
                        </span>

                    </template>

                </vue-good-table>
            
            </div>

        </div>
        
        <!-- modalComponent: orders / orders-wrapper -->
        <modal :modalData="modalData" :modalState="modalState" modalComponent="orders-wrapper" ></modal>
        

        </div>
        <!-- FULL -->

    </div><!-- end content template-padding -->

</template>

<script>

import firebase from "firebase";
import { mapGetters, mapState } from 'vuex'
import Cookies from 'js-cookie'
import axios from 'axios'
import moment from 'moment'
    
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
    
import analyzeToday from '@/components/analyzeToday.vue'    
import chartBlock from '@/components/chartBlock.vue'    
import chartBlockPie from '@/components/chartBlock-pie.vue'    
import modal from '@/components/modal.vue'    
import pieChart from '@/components/charts/pieChart.js'    
    
import helper from '@/helpers/helpers.js';
    
export default{
    name: "organizations",
    props:{
        contentType: { type: [ String ], default: 'full' }, /* full -> full page; overview -> overview source */ 
        parentPeriod: { type: [ Array ], default: null }, 
        passedAPPKEY:{ type : [String, Boolean], default: false },
    },
    components:{
        chartBlock,
        analyzeToday,
        modal,
        pieChart,
        chartBlockPie
    },
    data () {
        return {
            filter: '',
            sourceColumns:[
                {
                    //label: 'ORIGIN',
                    label: ' ',
                    field: 'origin',
                    //field: this.return_origin_column,
                    sortable: false,
                    html: true,
                    width: '50px',
                    tdClass: 'icon-cell',
                    hidden: true,
                },
                {
                    label: 'NAME',
                    field: 'name',
                    //field: this.returnName,
                    tdClass: 'font-weight-bold',
                    width: '450px'
                },
                
                {
                    label: 'TAG',
                    field: this.returnTag,
                    //field: this.returnName,
                    hidden: true,
                },
                {
                    label: 'CLICKS',
                    //field: 'clicks',
                    field: this.return_clicks_column,
                    type: 'number',
                    width: '100px'
                },
                {
                    label: 'SPEND',
                    field: 'ad_spent',
                    formatFn: this.return_adspent_column,
                    type: 'number',
                    width: '100px',
                    sortable: true,
                },
                
                {
                    label: 'REVENUE',
                    field: 'revenue',
                    //field: this.return_revenue_column,
                    //formatFn: this.return_price_column,
                    type: 'number',
                    tdClass: 'font-weight-bold',
                    width: '200px'
                },
                {
                    label: 'R. REVENUE',
                    field: 'reported_conversion_value',
                    formatFn: this.return_price_column,
                    type: 'number',
                    tdClass: 'font-weight-bold',
                    hidden: true,
                    sortable: true,
                },
                {
                    label: 'PROFIT',
                    //field: 'revenue',
                    field: this.return_PROFIT_column,
                    type: 'number',
                    html: true,
                    sortable: true,
                    width: '100px'
                },
                
                {
                    label: 'ROAS',
                    //field: 'revenue',
                    field: this.return_ROAS_column,
                    type: 'number',
                    html: true,
                    sortable: true,
                    width: '100px'
                },
                {
                    label: 'CPC',
                    //field: 'revenue',
                    field: this.return_CPC_column,
                    type: 'number',
                    html: true,
                    sortable: false,
                    width: '100px'
                },
                {
                    label: 'CTR',
                    //field: 'revenue',
                    field: this.return_CTR_column,
                    type: 'number',
                    html: true,
                    sortable: false,
                    width: '100px'
                },
                {
                    label: 'CPA',
                    //field: 'revenue',
                    field: this.return_CPA_column,
                    type: 'number',
                    html: true,
                    sortable: false,
                    width: '100px'
                },
                {
                    label: 'CR',
                    //field: 'revenue',
                    field: this.return_CR_column,
                    type: 'number',
                    html: true,
                    sortable: false,
                    width: '100px'
                },
                {
                    label: 'ROI',
                    //field: 'revenue',
                    field: this.return_ROI_column,
                    type: 'number',
                    html: true,
                    sortable: false,
                    width: '100px'
                },
                {
                    label: 'CONVERSIONS',
                    //field: 'revenue'
                    //field: this.countArray,
                    field: 'conversions',
                    type: 'number',
                    tdClass: 'font-weight-bold',
                    width: '150px'
                },
                {
                    label: 'R. SALES',
                    field: 'reported_conversions',
                    //field: this.countArray,
                    type: 'number',
                    hidden: true,
                },
            ],
            rows: [],
            SOURCES: [],
            reportResult: [],
            loaded: false,
            dataLoaded: false,
            selectedLead: null,
            modalData: null,
            modalState: false,
            ID: null,
            //startDate: moment().subtract(7, 'days').unix(),
            //endDate: moment().unix(),
            startDate: null,
            endDate: null,
            formatDate: 'D MMM YYYY',
            period: [ "", "" ],
            shortcuts: [
                { 
                    text: 'Today', 
                    onClick: () => {
                        let start = this.$moment(Date.now()).startOf('day').toDate();
                        let end = this.$moment(Date.now()).endOf('day').toDate();

                        let period = [ start, end ];
                        //console.log(period)
                        return period;
                    } 
                },
                {
                    text: 'Yesterday',
                    onClick: () => {
                        //let start = this.$moment( ).subtract(1,'d').format( "YYYY-MM-DD 00:00:00" )
                        //let end = this.$moment( ).subtract(1,'d').endOf('day').format( "YYYY-MM-DD 00:00:00" )
                        
                        let start = this.$moment( ).subtract(1,'d').toDate();
                        let end = this.$moment( ).subtract(1,'d').endOf('day').toDate();

                        let period = [ start, end ];
                        return period;
                    },
                },
                {
                    text: 'This Week',
                    onClick: () => {
                        let start = this.$moment(Date.now()).startOf('isoWeek').toDate();
                        let end = this.$moment(Date.now()).endOf('isoWeek').toDate();

                        let period = [ start, end ];
                        return period;
                    },
                },
                {
                    text: 'Last 7 days',
                    onClick: () => {
                        let start = this.$moment(Date.now()).subtract(7,'days').toDate();
                        let end = this.$moment(Date.now()).toDate();

                        let period = [ start, end ];
                        return period;
                    },
                },
                {
                    text: 'Last Week',
                    onClick: () => {
                        let start = this.$moment(Date.now()).subtract(1,'weeks').startOf('isoWeek').toDate();
                        let end = this.$moment(Date.now()).subtract(1,'weeks').endOf('isoWeek').toDate();

                        let period = [ start, end ];
                        return period;
                    },
                },
                {
                    text: 'This Month',
                    onClick: () => {
                        let start = this.$moment(Date.now()).startOf('month').toDate();
                        let end = this.$moment(Date.now()).endOf('month').toDate();

                        let period = [ start, end ];
                        return period;
                    },
                },
                {
                    text: 'Last 30 days',
                    onClick: () => {
                        let start = this.$moment(Date.now()).subtract(30,'days').toDate();
                        let end = this.$moment(Date.now()).toDate();

                        let period = [ start, end ];
                        return period;
                    },
                },
                {
                    text: 'Last Month',
                    onClick: () => {
                        let start = this.$moment(Date.now()).subtract(1,'months').startOf('month').toDate();
                        let end = this.$moment(Date.now()).subtract(1,'months').endOf('month').toDate();

                        let period = [ start, end ];
                        return period;
                    },
                },
                {
                    text: 'Last 3 months',
                    onClick: () => {
                        let start = this.$moment(Date.now()).subtract(3,'months').toDate();
                        let end = this.$moment(Date.now()).toDate();

                        let period = [ start, end ];
                        return period;
                    },
                },
                {
                    text: 'Last 6 months',
                    onClick: () => {
                        let start = this.$moment(Date.now()).subtract(6,'months').toDate();
                        let end = this.$moment(Date.now()).toDate();

                        let period = [ start, end ];
                        return period;
                    },
                },
            ],
            atributionOptions: [
                {"value": 'firstTouch', "text": "First touch" },
                
                {"value": 'lastTouch', "text": "Last touch" },
                {"value": 'lastTouch_nonDirect', "text": "Last non-direct" },
                {"value": 'lastTouch_FACEBOOK', "text": "Last touch - Facebook only" },
                {"value": 'lastTouch_GOOGLE', "text": "Last touch - Google only" },
                {"value": 'lastTouch_TIKTOK', "text": "Last touch - TikTok only" },
                
                {"value": 'liniar', "text": "Linear" },
                {"value": 'timeDecay', "text": "Time Decay" },
                {"value": 'timeDecay_paid', "text": "Time Decay - paid only" },
                {"value": 'uShaped', "text": "U Shaped" },
                {"value": 'uShaped_paid', "text": "U Shaped - paid only" },
            ],
            selectedAttribution: {"value": 'lastTouch_nonDirect', "text": "Last non-direct" },
            getSources: false,
            showEmpty: false,
            sourcesOrigin:[ {"value": null, "text": "All" },{"value": 'ATLASS', "text": "Atlass" } ],
            selected_sourcesOrigin: {"value": null, "text": "All" },
            filterTags:[],
            selectedTags:[],
            filterModules:[],
            selectedModules:[],
            
            chartOptions:{
                maxTicksLimit: 1,
                yAxesgridLines: false,
                xAxesgridLines: false
            },
            
            groupResults: [
                {"value": "ad", "text": "Ads" }, {"value": 'adset', "text": "Ad Sets / Groups" }, {"value": 'campaign', "text": "Campaign" }, {"value": 'account', "text": "Account" }
            ],
            groupBy: {"value": "ad", "text": "Ads" },
            
            RESULTS: [],
            
            LTV: {
                AVG_PURCHASE_VALUE: "-",
                AVG_PURCHASE_FREQ_RATE: "-",
                CUSTOMER_VALUE: "-",
                LTV: "-",
            },
            activeCustomers: [],
            
            itemsPerPage: 10,
            
            selectedChart: 'gross-revenue'
        }
    },
    beforeCreate: function (){
       // this.$store.dispatch(GET_USERS);
    },
    mounted: function(){
        
        this.loaded = true;
        this.init_period()
        //this.get_data();
        
        if( this.contentType == 'full' ){
            this.itemsPerPage = 30
        }
        
        //this.getTodaySales();
    },
    computed: {
    },
    methods: {
        init_period(){
            
            //INITIATE START
            //LAST 14 DAYS
            //let start = this.$moment(Date.now()).subtract(14,'d').format('D MMM YYYY');
            
            //START OF MONTH
            //let start = this.$moment(Date.now()).startOf('month').format('D MMM YYYY');
            
            //START OF DAY
            let start = this.$moment().startOf('day').format('D MMM YYYY');
            let end = this.$moment().format('D MMM YYYY');
            
            if( this.parentPeriod != null ){
                start = this.parentPeriod[0]
                end = this.parentPeriod[1]
            }

            this.period = [ start, end ];
            
            //console.log( this.period )
            
            this.get_sources()
            
        },
        get_sources(){
            
            //console.log(this.period)
            
            this.dataLoaded = false
            
            this.SOURCES = [{
                name: "TOTAL",
                origin: "ATLASS_DEFAULT",
                orders: [],
                clicks: 0,
                ad_spent: 0,
                ROI: null,
                ROAS: null,
                revenue: 0,
                sort: false,
                open: true,
                tag: ""
            },{
                name: "Unattributed",
                origin: "ATLASS_DEFAULT",
                orders: [],
                clicks: 0,
                ad_spent: 0,
                ROI: null,
                ROAS: null,
                revenue: 0,
                sort: false,
                tag: "unattributed"
            }]
            
            this.get_INTEGRATIONS_SOURCES( )
            
        },
        reset_sources(){
            this.SOURCES.forEach((source)=>{
                source.revenue = 0
                source.orders = []
            })
        },
        get_INTEGRATIONS_SOURCES( ){
          
            //let data = JSON.stringify( this.newOrg )/
            let headers = { 'Access-Control-Allow-Headers': '*', 'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json; charset=utf-8' }
            
            //console.log( this.period )
            
            let timezone = helper.getAccountTimezone()            
            let start = moment.tz(this.period[0], 'D MMM YYYY', timezone ).startOf('day').tz( 'UTC' ).unix()
            let end = moment.tz(this.period[1], 'D MMM YYYY', timezone ).endOf('day').tz( 'UTC' ).unix()
            //console.log( timezone + "| " + start + " - " + end )
            
            axios({ 
                method: 'POST', 
                url: process.env.ROOT_API+'/analyze/sources', 
                headers: headers, 
                data: { 
                    //"APPKEY": helper.getLoggedInOrganization( this.$store.getters.isAdmin ),
                    "APPKEY": ( ( this.passedAPPKEY != false ) ? this.passedAPPKEY : helper.getLoggedInOrganization( this.$store.getters.isAdmin ) ),
                    //"startDate":  moment(this.period[0]).unix(),
                    //"endDate":  moment(this.period[1]).endOf('day').unix(),
                    "startDate":  start,
                    "endDate":  end,
                } 
            })
            .then(resp => {
                //console.log(resp)
                if( resp.status == 200 ){
                    let campaigns = resp.data.body.sources;
                    
                    //PROCESS NOTIFICATIONS
                    let notifications = resp.data.body.notifications;
                    notifications.forEach((notification)=>{
                        this.$toast.warn({
                            title: 'Couldn`t fetch '+notification.APP+' sources.',
                            message:  'Reason: '+notification.statusMessage
                        })
                    })
                    
                    //PROCESS SOURCES
                    let sources = []
                    campaigns.forEach((campaign)=>{
                        
                        sources.push( JSON.parse( JSON.stringify( campaign ) ) )  
                        this.SOURCES.push( JSON.parse( JSON.stringify( campaign ) ) ) 
                        
                        //SUM FOR TOTAL
                        if( campaign.clicks != null ){
                            let clicks = parseInt( this.SOURCES[0].clicks ) + parseInt( campaign.clicks )
                            //console.log(campaign)
                            //console.log(clicks)  
                            this.SOURCES[0].clicks = clicks
                        }
                        
                        this.SOURCES[0].ad_spent += campaign.ad_spent
                        
                        let SourceName = campaign.origin.replace(/\S*/g, function (word) { return word.charAt(0) + word.slice(1).toLowerCase(); });
                        this.sourcesOrigin.push( { value: campaign.origin, text: SourceName } )
                        
                    })
                    //console.log(this.SOURCES)
                    
                    //Make array unique
                    this.sourcesOrigin = this.sourcesOrigin.filter((elem, index, self) => self.findIndex( (t) => {return (t.value === elem.value )}) === index)

                }else{
                    console.log("")
                }                
            })
            .then(function(){
                this.get_data()
            }.bind(this))
            .catch(error => {
                console.log(error)
                this.$toast.error({
                    title:'Error',
                    message:  'Error while fetching sources. Please reach out to us!'
                })
                this.get_data()
            }); //end axios 
            
        },
        
        refresh_chart( $event ){
            //console.log($event)
            this.rows = []
            if( this.period[0] == null || this.period[1] == null ){
                this.init_period()
            }else{
                this.get_sources()
            }
            
        },
        
        get_data: function( ){
            
             //let data = JSON.stringify( this.newOrg )/
            let headers = { 'Access-Control-Allow-Headers': '*', 'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json; charset=utf-8' }
            
            //console.log( this.period )
            
            this.startDate = moment(this.period[0]).unix()
            this.endDate = moment(this.period[1]).endOf('day').unix()
            
            let timezone = helper.getAccountTimezone()            
            let start = moment.tz(this.period[0], 'D MMM YYYY', timezone ).startOf('day').tz( 'UTC' ).unix()
            let end = moment.tz(this.period[1], 'D MMM YYYY', timezone ).endOf('day').tz( 'UTC' ).unix()
            //console.log( timezone + "| " + start + " - " + end )
            
            axios({ 
                method: 'POST', 
                url: process.env.ROOT_API+'/analyze/sales', 
                //url: process.env.ROOT_API+'/analyze/sales-new', 
                //url: 'https://sql.theatlass.com/api-v2/analyze/sales.php', 
                headers: headers, 
                data: { 
                    //"APPKEY": helper.getLoggedInOrganization( this.$store.getters.isAdmin ),
                    "APPKEY": ( ( this.passedAPPKEY != false ) ? this.passedAPPKEY : helper.getLoggedInOrganization( this.$store.getters.isAdmin ) ),
                    //"startDate":  moment(this.period[0]).unix(),
                    //"endDate":  moment(this.period[1]).endOf('day').unix(),
                    "startDate":  start,
                    "endDate":  end,
                } 
            })
            .then(resp => {
                //console.log(resp)
                if( resp.status == 200 ){

                    //let sales = resp.data.body;
                    let sales = resp.data.data;
                    
                    //console.log(sales.length)
                    
                    if( sales.length > 0 ){
                        sales.forEach((item)=>{

                            //this.rows.push(item);     

                            item.price = parseFloat(item.price)

                            this.filterTags.push( { value: item.tag, text: item.tag } )
                            if( item.orderItems ){
                                item.orderItems.forEach((product)=>{
                                    this.filterTags.push( { value: product.tag, text: product.Name } )
                                })
                            }

                            if( item.tags ){
                                item.tags.forEach((tag)=>{
                                    if( typeof tag == "String" ){
                                        //from SQL
                                        if( tag[0] == "!" ){
                                            this.filterTags.push( { value: tag, text: tag } )
                                        }
                                        //from SQL
                                    }else{
                                        //from firebase
                                        if( tag.type != 1 ){
                                            this.filterTags.push( { value: tag.tag, text: tag.tag } )
                                        }
                                        //from firebase
                                    }
                                        
                                })
                            }

                            //ADD MODULES FOR SELECTION
                            if( item.integrationTag ){
                                this.filterModules.push( { value: item.integrationTag, text: item.integrationTag } )
                            }else{
                                //
                                if( item.origin == 'ATLASS' ){
                                    this.filterModules.push( { value: 'ATLASS', text: 'ATLASS' } )
                                }

                            }

                            //this.attribution_LastClick( item )
                            //this.checkSelectedAttribution( item )

                        })
                        
                        this.SORT_SOURCES()
                        
                    }else{
                        //console.log("No sales")
                        this.SORT_SOURCES()
                    }
                    
                    
                    return sales
                    
                }else{
                    console.log(resp)
                }                
                
            })
            .then(function(sales){
                
                this.rows = sales
                //this.calculateLTV( sales )
                let periodDiff = this.$moment(this.period[1], 'D MMM YYYY' ).unix() - this.$moment(this.period[0], 'D MMM YYYY' ).unix()
                
                //this.get_LTV()
                //this.get_activeCustomers()
                    
                this.parseFilteredConversions()
                
                //console.log("done")
                this.filterTags = this.filterTags.filter((elem, index, self) => self.findIndex( (t) => {return (t.value === elem.value )}) === index)
                this.filterModules = this.filterModules.filter((elem, index, self) => self.findIndex( (t) => {return (t.value === elem.value )}) === index)
                //this.dataLoaded = true;
                
            }.bind(this))
            .catch(error => {
                
                console.log(error)
                this.$toast.error({
                    title:'Error',
                    message:  'Error while fetching sources. Please reach out to us!'
                })
                
            }); //end axios 
            
        },
 
        get_LTV: function( ){
            
            let headers = { 'Access-Control-Allow-Headers': '*', 'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json; charset=utf-8' }
            
            this.startDate = moment(this.period[0]).unix()
            this.endDate = moment(this.period[1]).endOf('day').unix()
            
            let timezone = helper.getAccountTimezone()            
            let start = moment.tz(this.period[0], 'D MMM YYYY', timezone ).startOf('day').tz( 'UTC' ).unix()
            let end = moment.tz(this.period[1], 'D MMM YYYY', timezone ).endOf('day').tz( 'UTC' ).unix()
            
            let periodDiff = end - start
            if( ( periodDiff ) >= ( 60*60*24*27 ) ){
                
                axios({ 
                    method: 'POST', 
                    //url: process.env.ROOT_API+'/analyze/sales', 
                    //url: process.env.ROOT_API+'/analyze/stats/ltv', 
                    url: 'https://sql.theatlass.com/api-v2/analyze/stats.php?query=ltv', 
                    headers: headers, 
                    data: { 
                        //"APPKEY": helper.getLoggedInOrganization( this.$store.getters.isAdmin ),
                        "APPKEY": ( ( this.passedAPPKEY != false ) ? this.passedAPPKEY : helper.getLoggedInOrganization( this.$store.getters.isAdmin ) ),
                        //"startDate":  moment(this.period[0]).unix(),
                        //"endDate":  moment(this.period[1]).endOf('day').unix(),
                        "startDate":  start,
                        "endDate":  end,
                    } 
                })
                .then(resp => {
                    //console.log(resp)
                    if( resp.status == 200 && resp.data.data != null ){
                        this.LTV = resp.data.data
                    }

                })
                .then(function(sales){

                }.bind(this))
                .catch(error => {

                    console.log(error)
                    this.$toast.error({
                        title:'Error',
                        message:  'Error calculating LTV. Please reach out to us!'
                    })

                }); //end axios 
                
            }else{
                this.LTV = {"TOTAL_REVENUE":"-", "NUMBER_OF_PURCHASES":"-", "NUMBER_OF_CUSTOMERS":"-", "AVG_PURCHASE_VALUE": "-", "AVG_PURCHASE_FREQ_RATE":"-", "CUSTOMER_VALUE":"-", "SUM_OF_CUSTOMER_LIFESPAN":"-", "TOTAL_CUSTOMERS":427, "AVG_CUSTOMER_LIFESPAN":"-", "LTV":"-"}
            }
            
        },
 
        get_activeCustomers: function( ){
            
            let headers = { 'Access-Control-Allow-Headers': '*', 'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json; charset=utf-8' }
            
            this.startDate = moment(this.period[0]).unix()
            this.endDate = moment(this.period[1]).endOf('day').unix()
            
            let timezone = helper.getAccountTimezone()            
            let start = moment.tz(this.period[0], 'D MMM YYYY', timezone ).startOf('day').tz( 'UTC' ).unix()
            let end = moment.tz(this.period[1], 'D MMM YYYY', timezone ).endOf('day').tz( 'UTC' ).unix()
            
            let periodDiff = end - start
                
            let groupBy = 'hour'
            if( ( periodDiff ) > ( 60*60*24*3 ) ){
                groupBy = 'day'
            }
            if( ( periodDiff ) > ( 60*60*24*61 ) ){
                groupBy = 'month'
            }
            
            axios({ 
                method: 'POST', 
                //url: process.env.ROOT_API+'/analyze/sales', 
                url: process.env.ROOT_API+'/analyze/stats/customers', 
                //url: 'https://atlass-302217.ew.r.appspot.com/analyze/stats/ltv', 
                headers: headers, 
                data: { 
                    //"APPKEY": helper.getLoggedInOrganization( this.$store.getters.isAdmin ),
                    "APPKEY": ( ( this.passedAPPKEY != false ) ? this.passedAPPKEY : helper.getLoggedInOrganization( this.$store.getters.isAdmin ) ),
                    //"startDate":  moment(this.period[0]).unix(),
                    //"endDate":  moment(this.period[1]).endOf('day').unix(),
                    "startDate":  start,
                    "endDate":  end,
                    "groupBy": groupBy
                } 
            })
            .then(resp => {
                console.log(resp)
                if( resp.status == 200 ){
                    let data = resp.data.body
                    
                    let format = 'YYYY-MM'
                    if( groupBy == 'day' ){ format = 'YYYY-MM-DD' }
                    if( groupBy == 'hour' ){ format = 'YYYY-MM-DD HH' }
                    
                    let activeCustomers = []
                    data.forEach((row)=>{
                        let date = this.$moment(row.date, format).format('MMM YYYY')
                        if( groupBy == 'day' ){ date = this.$moment(row.date, format).format('MMM DD') }
                        if( groupBy == 'houe' ){ date = this.$moment(row.date, format).format('HH') }
                        let datetime = this.$moment(row.date, format,'UTC').unix()
                        row.date = date
                        row.datetime = datetime
                        
                        activeCustomers.push( { date: row.date, count: row.customers } )
                    })
                    
                    this.activeCustomers = activeCustomers
                }
                
            })
            .then(function(sales){
                
            }.bind(this))
            .catch(error => {
                
                console.log(error)
                this.$toast.error({
                    title:'Error',
                    message:  'Error calculating LTV. Please reach out to us!'
                })
                
            }); //end axios 
            
        },
 
        get_revenueQuota: function( ){
            
            let headers = { 'Access-Control-Allow-Headers': '*', 'Access-Control-Allow-Origin': '*', 'Content-Type': 'application/json; charset=utf-8' }
            
            this.startDate = moment(this.period[0]).unix()
            this.endDate = moment(this.period[1]).endOf('day').unix()
            
            let timezone = helper.getAccountTimezone()            
            let start = moment.tz(this.period[0], 'D MMM YYYY', timezone ).startOf('day').tz( 'UTC' ).unix()
            let end = moment.tz(this.period[1], 'D MMM YYYY', timezone ).endOf('day').tz( 'UTC' ).unix()
            
            axios({ 
                method: 'POST', 
                //url: process.env.ROOT_API+'/analyze/sales', 
                url: process.env.ROOT_API+'/analyze/stats/revenue-quota', 
                headers: headers, 
                data: { 
                    //"APPKEY": helper.getLoggedInOrganization( this.$store.getters.isAdmin ),
                    "APPKEY": ( ( this.passedAPPKEY != false ) ? this.passedAPPKEY : helper.getLoggedInOrganization( this.$store.getters.isAdmin ) ),
                    //"startDate":  moment(this.period[0]).unix(),
                    //"endDate":  moment(this.period[1]).endOf('day').unix(),
                    "startDate":  start,
                    "endDate":  end,
                } 
            })
            .then(resp => {
                console.log(resp)
            })
            .then(function(sales){
                
            }.bind(this))
            .catch(error => {
                
                console.log(error)
                this.$toast.error({
                    title:'Error',
                    message:  'Error calculating LTV. Please reach out to us!'
                })
                
            }); //end axios 
            
        },
 
        switchAttribution( ){
            
            this.parseFilteredConversions()
            
        },
        
        checkSelectedAttribution( item ){
            
            let order = item;
            
            //console.log(order)
            
            if( this.selectedAttribution.value == 'firstTouch' ){
                //console.log( 'first touch' )
                this.attribution_FirstClick( item )

            }else if( this.selectedAttribution.value == 'lastTouch' ){
                //console.log( 'last touch' )
                this.attribution_LastClick( item )

            }else if( this.selectedAttribution.value == 'lastTouch_FACEBOOK' ){
                //console.log( 'last touch' )
                this.attribution_LastClick_FACEBOOK( item )

            }else if( this.selectedAttribution.value == 'lastTouch_GOOGLE' ){
                //console.log( 'last touch' )
                this.attribution_LastClick_GOOGLE( item )

            }else if( this.selectedAttribution.value == 'lastTouch_TIKTOK' ){
                //console.log( 'last touch' )
                this.attribution_LastClick_TIKTOK( item )

            }else if( this.selectedAttribution.value == 'lastTouch_nonDirect' ){
                //console.log( 'last touch' )
                this.attribution_LastClick_nonDirect( item )

            }else if( this.selectedAttribution.value == 'liniar' ){
                //console.log( 'last touch' )
                this.attribution_liniar( item )

            }else if( this.selectedAttribution.value == 'timeDecay' ){
                //console.log( 'last touch' )
                this.attribution_timeDecay( item )

            }else if( this.selectedAttribution.value == 'timeDecay_paid' ){
                //console.log( 'last touch' )
                this.attribution_timeDecay_paid( item )

            }else if( this.selectedAttribution.value == 'uShaped' ){
                //console.log( 'last touch' )
                this.attribution_uShaped( item )

            }else if( this.selectedAttribution.value == 'uShaped_paid' ){
                //console.log( 'last touch' )
                this.attribution_uShaped_paid( item )

            }
            
        },
        
        SUM_TOTAL(order){
            
            ////////////////////////////////
            //ISSUE -> should not work if filters product tags does not comply
            ////////////////////////////////
            
            //ADD ORDER TO TOTAL SOURCE
            //ADD TO ALL
            //console.log( order )
            //console.log( this.SOURCES[0].orders.find(el => el.id === order.id ) )
            
            //console.log( this.SOURCES[0].revenue )
            //console.log( order.price )
            
            if( this.SOURCES[0].orders.find(el => el.id === order.id ) == undefined ){
                
                this.SOURCES[0].orders.push( order )
                if( order.status != 'refunded' && order.status != 'failed' ){
                    this.SOURCES[0].revenue += parseFloat(order.price)
                }
                
            }
            
            
            
        },
        
        parseFilteredConversions(){
            
            //console.log( this.selectedAttribution.value )
            //console.log( this.selected_sourcesOrigin )
            
            this.dataLoaded = false
            this.reset_sources(  ); 
            //console.log( this.SOURCES )
            //console.log( this.rows )
            
            let data = this.rows
            if( this.rows.length > 0 ){
                
                data.forEach(item => {
                    //console.log(item)
                    this.checkSelectedAttribution( item )
                })
                
                this.SORT_SOURCES()
                                
            }else{
                //this.dataLoaded = true
                this.SORT_SOURCES()
                //setTimeout(function(){ this.dataLoaded = true }.bind(this), 100 );
            }
            
        },
        
        attribution_LastClick( order ){
            
            let sourceTag = {tag: 'unattributed'}
            if( order.lastTouch != 'unattributed' ){
                //sourceTag = order.lastTouch
            }
            
            if( order.touchpoints.length > 0 ){
                //sourceTag = order.firstTouch
                sourceTag = order.touchpoints[ order.touchpoints.length - 1 ]
            }
            
            //console.log("last touch: "+sourceTag)
            this.attribute_conversion( order, sourceTag )

        },
        
        attribution_LastClick_FACEBOOK( order ){
            
            let sourceTag = {tag: 'unattributed' }
            if( order.touchpoints.length > 0 ){
                let touchpoints = order.touchpoints
                
                let ADS = []
                touchpoints.forEach((touchpoint)=>{if( touchpoint.origin == "FACEBOOK" && touchpoint.type == 1 ){ ADS.push( touchpoint ) } })

                sourceTag = ADS[ADS.length - 1]
                if( sourceTag == undefined ){
                    //sourceTag = order.touchpoints[ order.touchpoints.length - 1 ]
                    sourceTag = {name:"Other",tag: 'other'}
                }
                this.attribute_conversion( order, sourceTag )
                
            }else{
                this.attribute_conversion( order, sourceTag )
            }
            //console.log("first touch: "+sourceTag)

        },
        
        attribution_LastClick_GOOGLE( order ){
            
            let sourceTag = {tag: 'unattributed' }
            if( order.touchpoints.length > 0 ){
                let touchpoints = order.touchpoints
                
                let ADS = []
                touchpoints.forEach((touchpoint)=>{if( touchpoint.origin == "GOOGLE" && touchpoint.type == 1 ){ ADS.push( touchpoint ) } })

                sourceTag = ADS[ADS.length - 1]
                if( sourceTag == undefined ){
                    //sourceTag = order.touchpoints[ order.touchpoints.length - 1 ]
                    sourceTag = {name:"Other",tag: 'other'}
                }
                this.attribute_conversion( order, sourceTag )
                
            }else{
                this.attribute_conversion( order, sourceTag )
            }
            //console.log("first touch: "+sourceTag)

        },
        
        attribution_LastClick_TIKTOK( order ){
            
            let sourceTag = {tag: 'unattributed' }
            if( order.touchpoints.length > 0 ){
                let touchpoints = order.touchpoints
                
                let ADS = []
                touchpoints.forEach((touchpoint)=>{if( touchpoint.origin == "TIKTOK" && touchpoint.type == 1 ){ ADS.push( touchpoint ) } })

                sourceTag = ADS[ADS.length - 1]
                if( sourceTag == undefined ){
                    //sourceTag = order.touchpoints[ order.touchpoints.length - 1 ]
                    sourceTag = {name:"Other",tag: 'other'}
                }
                this.attribute_conversion( order, sourceTag )
                
            }else{
                this.attribute_conversion( order, sourceTag )
            }
            //console.log("first touch: "+sourceTag)

        },
        
        attribution_LastClick_nonDirect( order ){
            
            let sourceTag = {tag: 'unattributed' }
            if( order.touchpoints.length > 0 ){
                let touchpoints = order.touchpoints
                
                let ADS = []
                touchpoints.forEach((touchpoint)=>{if( touchpoint.external_id && touchpoint.type == 1 ){ ADS.push( touchpoint ) } })
                //console.log(ADS)
                
                /*
                if( ADS.length > 0 ){
                    ADS.sort((a, b) => b.datetime - a.datetime);

                    //sourceTag = ADS[ADS.length - 1]
                    sourceTag = ADS[0]
                    //console.log(sourceTag)
                    this.attribute_conversion( order, sourceTag )
                }else{
                    sourceTag = touchpoints[touchpoints.length - 1]
                    this.attribute_conversion( order, sourceTag )
                }
                */
                
                sourceTag = ADS[ADS.length - 1]
                if( sourceTag == undefined ){
                    //sourceTag = order.touchpoints[ order.touchpoints.length - 1 ]
                    sourceTag = {name:"Organic",tag: 'organic'}
                }
                this.attribute_conversion( order, sourceTag )
                
            }else{
                this.attribute_conversion( order, sourceTag )
            }
            //console.log("first touch: "+sourceTag)

        },
        
        attribution_FirstClick( order ){
            
            let sourceTag = {tag: 'unattributed' }
            if( order.firstTouch != 'unattributed' ){
                //sourceTag = order.firstTouch
            }
            
            if( order.touchpoints.length > 0 ){
                //sourceTag = order.firstTouch
                sourceTag = order.touchpoints[0]
            }
            
            //console.log("first touch: "+sourceTag)
            this.attribute_conversion( order, sourceTag )
            
            
        },
        
        attribution_liniar( order ){
            
            let sourceTag = {tag: 'unattributed' }
            if( order.touchpoints.length > 0 ){
                let touchpoints = []
                order.touchpoints.forEach((tag)=>{ if( tag.type == 1 ){ touchpoints.push( tag ) } })
                let touchpointsCount = touchpoints.length
                
                let DIVISION = touchpointsCount
                touchpoints.forEach((touchpoint)=>{
                    //sourceTag = touchpoint
                    this.attribute_conversion( order, touchpoint, DIVISION )
                })
            }else{
                this.attribute_conversion( order, sourceTag )
            }
            //console.log("first touch: "+sourceTag)
            
        },
        
        attribution_timeDecay( order ){
            
            //console.log( Math.pow( 2, (-8/7)) )
            
            let sourceTag = {tag: 'unattributed' }
            if( order.touchpoints.length > 0 ){
                let touchpoints = []
                order.touchpoints.forEach((tag)=>{ if( tag.type == 1 ){ touchpoints.push( tag ) } })
                let touchpointsCount = touchpoints.length
                
                //HALFLIFE is 7 days ( 7 * 24 hours )
                //TIMEPARAMETER is in 60 * 60 * 24 days ( 60 * 60 hours )
                let halfLife = 7 * 24
                let timeParameter = ( 60 * 60 )
                let decayTotal = 0
                touchpoints.forEach((touchpoint, index)=>{
                    let decayFactor = Math.floor(( order.datetime - touchpoint.datetime ) / timeParameter ) 
                    let decay = Math.pow( 2, (- decayFactor/ halfLife ) )
                    decayTotal += decay
                    
                })
                
                //console.log( decayTotal )
                
                touchpoints.forEach((touchpoint, index)=>{
                    
                    let decayFactor = Math.floor(( order.datetime - touchpoint.datetime ) / timeParameter ) 
                    let decay = Math.pow( 2, (- decayFactor/ halfLife ) )
                    //console.log(decay)
                    
                    
                    let DIVISION = decayTotal / decay
                    //console.log( DIVISION )
                    this.attribute_conversion( order, touchpoint, DIVISION )
                    //4 la puterea 3
                    //Math.pow(4, 3);
                })
                
            }else{
                this.attribute_conversion( order, sourceTag )
            }
            //console.log("first touch: "+sourceTag)
            
        },
        
        attribution_timeDecay_paid( order ){
            
            //console.log( Math.pow( 2, (-8/7)) )
            
            let sourceTag = {tag: 'unattributed' }
            if( order.touchpoints.length > 0 ){
                let touchpoints = []
                order.touchpoints.forEach((tag)=>{ if( tag.type == 1 && tag.external_id ){ touchpoints.push( tag ) } })
                if( touchpoints.length == 0 ){
                    order.touchpoints.forEach((tag)=>{ if( tag.type == 1 ){ touchpoints.push( tag ) } })
                }
                let touchpointsCount = touchpoints.length
                
                //HALFLIFE is 7 days ( 7 * 24 hours )
                //TIMEPARAMETER is in 60 * 60 * 24 days ( 60 * 60 hours )
                let halfLife = 7 * 24
                let timeParameter = ( 60 * 60 )
                let decayTotal = 0
                touchpoints.forEach((touchpoint, index)=>{
                    let decayFactor = Math.floor(( order.datetime - touchpoint.datetime ) / timeParameter ) 
                    let decay = Math.pow( 2, (- decayFactor/ halfLife ) )
                    decayTotal += decay
                    
                })
                
                //console.log( decayTotal )
                
                touchpoints.forEach((touchpoint, index)=>{
                    
                    let decayFactor = Math.floor(( order.datetime - touchpoint.datetime ) / timeParameter ) 
                    let decay = Math.pow( 2, (- decayFactor/ halfLife ) )
                    //console.log(decay)
                    
                    
                    let DIVISION = decayTotal / decay
                    //console.log( DIVISION )
                    this.attribute_conversion( order, touchpoint, DIVISION )
                    //4 la puterea 3
                    //Math.pow(4, 3);
                })
                
            }else{
                this.attribute_conversion( order, sourceTag )
            }
            //console.log("first touch: "+sourceTag)
            
        },
        
        attribution_uShaped( order ){
            
            let sourceTag = {tag: 'unattributed' }
            if( order.touchpoints.length > 0 ){
                let touchpoints = []
                order.touchpoints.forEach((tag)=>{ if( tag.type == 1 ){ touchpoints.push( tag ) } })
                let touchpointsCount = touchpoints.length
                
                let DIVISION = 1;
                    
                touchpoints.forEach((touchpoint, index)=>{
                    if( touchpointsCount == 1 ){
                        DIVISION = 1;
                        this.attribute_conversion( order, touchpoint, DIVISION )
                    }else if( touchpointsCount == 2 ){
                        DIVISION = 2;
                        this.attribute_conversion( order, touchpoint, DIVISION )
                    }else if( touchpointsCount > 2 ){
                        //console.log(index)
                        //console.log(touchpoints)
                        //if touchpoints is first or last -> DIVISION = 35%
                        //else -> DIVISION =  
                        if( index == 0 || index == touchpointsCount - 1 ){
                            DIVISION = 100/35
                            this.attribute_conversion( order, touchpoint, DIVISION )
                        }else{
                            //if touchpoint is not first or last
                            DIVISION = (100/30)*( touchpointsCount - 2 )
                            this.attribute_conversion( order, touchpoint, DIVISION )
                        }
                            
                    }
                })
                
            }else{
                this.attribute_conversion( order, sourceTag )
            }
            //console.log("first touch: "+sourceTag)
            
        },
        
        attribution_uShaped_paid( order ){
            
            let sourceTag = {tag: 'unattributed' }
            if( order.touchpoints.length > 0 ){
                let touchpoints = []
                order.touchpoints.forEach((tag)=>{ if( tag.type == 1 && tag.external_id ){ touchpoints.push( tag ) } })
                if( touchpoints.length == 0 ){
                    order.touchpoints.forEach((tag)=>{ if( tag.type == 1 ){ touchpoints.push( tag ) } })
                }
                let touchpointsCount = touchpoints.length
                
                let DIVISION = 1;
                    
                touchpoints.forEach((touchpoint, index)=>{
                    if( touchpointsCount == 1 ){
                        DIVISION = 1;
                        this.attribute_conversion( order, touchpoint, DIVISION )
                    }else if( touchpointsCount == 2 ){
                        DIVISION = 2;
                        this.attribute_conversion( order, touchpoint, DIVISION )
                    }else if( touchpointsCount > 2 ){
                        //console.log(index)
                        //console.log(touchpoints)
                        //if touchpoints is first or last -> DIVISION = 35%
                        //else -> DIVISION =  
                        if( index == 0 || index == touchpointsCount - 1 ){
                            DIVISION = 100/35
                            this.attribute_conversion( order, touchpoint, DIVISION )
                        }else{
                            //if touchpoint is not first or last
                            DIVISION = (100/30)*( touchpointsCount - 2 )
                            this.attribute_conversion( order, touchpoint, DIVISION )
                        }
                            
                    }
                })
                
            }else{
                this.attribute_conversion( order, sourceTag )
            }
            //console.log("first touch: "+sourceTag)
            
        },
        
        checkSelectedTags( order ){
            let found = false
            
            //console.log("--------------------------------")
            //console.log(order)
            
            this.selectedTags.forEach((tag)=>{
                
                if( tag.value == order.tag ){
                    found = true
                }
                
                if( !found && order.orderItems ){
                    order.orderItems.forEach((item)=>{
                        if( tag.value == item.tag ){
                            found = true
                        }
                    })
                    
                } 
                                
                if( !found && order.tags ){
                    order.tags.forEach((item)=>{
                        if( tag.value == item ){
                            found = true
                        }
                        //console.log( tag.value + " = " + item.tag )
                    })
                    
                }
                                        
            })
                        
            return found
            
        },
        
        checkSelectedModules( order ){
            let found = false
            
            //console.log("--------------------------------")
            //console.log(order)
            
            this.selectedModules.forEach((tag)=>{
                
                if( order.integrationTag && tag.value == order.integrationTag ){
                    found = true
                }else if( !order.integration && order.origin == tag.value ){
                    found = true
                }
                                        
            })
                        
            return found
            
        },
        
        attribute_conversion( order, sourceTag, division = 1 ){
            
            let PRICE = order.price / division
            
            //console.log( order )
            //console.log( sourceTag )
            
            //process filters
            if(  
                //( this.selected_sourcesOrigin == null || (this.selected_sourcesOrigin != null && this.selected_sourcesOrigin.value == sourceTag.origin ) )  && 
                ( this.selectedTags.length == 0 || (this.selectedTags.length > 0 && this.checkSelectedTags(order) ) ) &&
                ( this.selectedModules.length == 0 || (this.selectedModules.length > 0 && this.checkSelectedModules(order) ) ) 
              ){
                
                
                let found_id = this.SOURCES.find(el => el.external_id === sourceTag.external_id && el.origin === sourceTag.origin )
                
                if( sourceTag.external_id && found_id != undefined ){
                    
                    //CHECK IF EXTERNAL ID IS FOUND IN SOURCES
                    //let found_id = this.SOURCES.find(el => el.external_id === sourceTag.external_id && el.origin === sourceTag.origin )
                    
                    //console.log( 'Found: ' )
                    //console.log( found_id )
                    
                    for( var i = 0; i < this.SOURCES.length; i++ ){
                        
                        if( this.SOURCES[i].external_id == sourceTag.external_id && this.SOURCES[i].origin == sourceTag.origin  ){
                            if( order.status != 'refunded' && order.status != 'failed' ){
                                this.SOURCES[i].revenue += PRICE
                            }
                            this.SOURCES[i].orders.push( order )
                            
                            this.SUM_TOTAL(order)
                        }
                        
                    }
                    
                }else{
                    
                    const found = this.SOURCES.find(el => el.tag === sourceTag.tag );
                    
                    if (found == undefined){
                        //CREATE SOURCE
                        let name = this.tagToName( sourceTag.tag )
                        let SOURCE = { name: name, origin: sourceTag.origin, tag: sourceTag.tag, revenue: 0, orders:[ ] }
                        /*
                        if( sourceTag.params.gclid ){
                            //SOURCE.origin = "GOOGLE"
                        }else
                        if( sourceTag.params.fbclid ){
                            //SOURCE.origin = "FACEBOOK"
                        }else
                        if( sourceTag.params.fbclid ){
                            //SOURCE.origin = "FACEBOOK"
                        }else
                        if( sourceTag.params.ttclid ){
                            //SOURCE.origin = "TIKTOK"
                        }else
                        */
                        if( !sourceTag.origin ){
                            SOURCE.origin = "ATLASS"
                        }
                        //let SOURCE = { name: name, tag: sourceTag.tag, revenue: 0, orders:[ ] }

                        //ADD ORDER TO IT IF STATUS IS PAID
                        if( order.status != 'refunded' && order.status != 'failed' ){
                            SOURCE.revenue += PRICE
                        }
                        SOURCE.orders.push( order )

                        this.SOURCES.push( SOURCE );
                        
                        this.SUM_TOTAL(order)
                        
                    }else{
                        for( var i = 0; i < this.SOURCES.length; i++ ){
                            if( this.SOURCES[i].tag == sourceTag.tag  ){
                                if( order.status != 'refunded' && order.status != 'failed' ){
                                    this.SOURCES[i].revenue += PRICE
                                }
                                this.SOURCES[i].orders.push( order )
                                
                                this.SUM_TOTAL(order)
                            }
                        }
                    }
                    
                }

                //this.SOURCES.sort((a, b) => b.revenue - a.revenue);
                //this.SORT_SOURCES()
                
            }else{
                                
                //this.SORT_SOURCES()
            }
    
        },
        
        SORT_SOURCES: function(){
          
            //console.log(this.SOURCES)
            
            //GROUP RESULTS
            //console.log( this.groupBy )
            if( this.groupBy == null ){
                this.groupBy = {"value": "ad", "text": "Ads" }
            }
            
            if( this.groupBy.value != 'ad' ){
                let RESULTS = []
                let SOURCES = this.SOURCES
                SOURCES.forEach((s)=>{

                    const source = s

                    //console.log("source")
                    //console.log(source)

                    if( source.origin == 'ATLASS_DEFAULT' ){
                        RESULTS.push( source )
                    }
                    else if( ( source.origin == "FACEBOOK" || source.origin == "GOOGLE" || source.origin == "TIKTOK" ) && source.campaign && source.adset ){

                        if( this.groupBy.value == 'ad' || this.groupBy == null ){
                            RESULTS.push( source )
                        }
                        else if( this.groupBy.value == 'campaign' ){

                            let found = RESULTS.find(el => el.external_id === source.campaign.id && el.origin === source.origin && el.type == 'campaign' )
                            if( found == undefined ){
                                let GROUP = { name: source.campaign.name, external_id: source.campaign.id, type: 'campaign', origin: source.origin, tag: this.nameToTag(source.campaign.name, '@'), revenue: 0, clicks:0, ad_spent: 0, orders: source.orders }
                                //GROUP.orders = source.orders
                                //source.orders.forEach((order)=>{ GROUP.orders.push(order) })
                                GROUP.clicks = source.clicks
                                GROUP.impressions = source.impressions
                                GROUP.ad_spent = source.ad_spent
                                GROUP.revenue = source.revenue
                                GROUP.reported_conversions = source.reported_conversions
                                GROUP.reported_conversion_value = source.reported_conversion_value

                                GROUP.data = source.data
                                GROUP.stats = source.stats
                                GROUP.account_id = source.account_id
                                GROUP.account_name = source.account_name

                                RESULTS.push( GROUP )
                            }else{

                                RESULTS.forEach((group)=>{
                                    if( group.external_id == source.campaign.id ){
                                        
                                        group.clicks += source.clicks
                                        group.impressions += source.impressions
                                        group.ad_spent += source.ad_spent
                                        group.revenue += parseFloat( source.revenue )
                                        if( source.reported_conversion_value ){
                                            group.reported_conversion_value += parseFloat( source.reported_conversion_value )
                                        }
                                        if( source.reported_conversions ){
                                            group.reported_conversions += parseFloat( source.reported_conversions )
                                        }    
                                        if( source.orders.length > 0 ){
                                            let orders = group.orders.concat(source.orders)
                                            group.orders = orders
                                            //source.orders.forEach((order)=>{ group.orders.push(order) })
                                        }

                                        //console.log("Found")
                                        //console.log(group)
                                    }
                                })

                            }

                        }//end else group by campaign
                        else if( this.groupBy.value == 'account' ){

                            let found = RESULTS.find(el => el.external_id === source.account_id && el.origin === source.origin && el.type == 'account' )
                            if( found == undefined ){
                                let GROUP = { name: source.account_name + " ( ID: "+ source.account_id +" ) ", external_id: source.account_id, type: 'account', origin: source.origin, tag: this.nameToTag(source.account_name, '@'), revenue: 0, clicks:0, ad_spent: 0, orders: source.orders }
                                //GROUP.orders = source.orders
                                GROUP.clicks = source.clicks
                                GROUP.impressions = source.impressions
                                GROUP.ad_spent = source.ad_spent
                                GROUP.revenue = source.revenue
                                GROUP.reported_conversions = source.reported_conversions
                                GROUP.reported_conversion_value = source.reported_conversion_value

                                GROUP.data = source.data
                                GROUP.stats = source.stats
                                GROUP.account_id = source.account_id
                                GROUP.account_name = source.account_name

                                //console.log("Created")
                                //console.log(GROUP)
                                RESULTS.push( GROUP )
                            }else{

                                RESULTS.forEach((group)=>{
                                    if( group.external_id == source.account_id ){
                                        //console.log( source )
                                        group.clicks += source.clicks
                                        group.impressions += source.impressions
                                        group.ad_spent += source.ad_spent
                                        group.revenue += parseFloat( source.revenue )
                                        if( source.reported_conversion_value ){
                                            group.reported_conversion_value += parseFloat( source.reported_conversion_value )
                                        }
                                        if( source.reported_conversions ){
                                            group.reported_conversions += parseFloat( source.reported_conversions )
                                        }                                        
                                        if( source.orders.length > 0 ){
                                            let orders = group.orders.concat(source.orders)
                                            group.orders = orders
                                            //source.orders.forEach((order)=>{ group.orders.push(order) })
                                        }
                                    }
                                })

                            }

                        }//end else group by account
                        else if( this.groupBy.value == 'adset' ){

                            let found = RESULTS.find(el => el.external_id === source.adset.id && el.origin === source.origin && el.type == 'adset' )
                            if( found == undefined ){
                                let GROUP = { name: source.adset.name, external_id: source.adset.id, type: 'adset', origin: source.origin, tag: this.nameToTag(source.adset.name, '@'), revenue: 0, clicks:0, ad_spent: 0, orders:source.orders }
                                //GROUP.orders = source.orders
                                GROUP.clicks = source.clicks
                                GROUP.impressions = source.impressions
                                GROUP.ad_spent = source.ad_spent
                                GROUP.revenue = source.revenue
                                GROUP.reported_conversions = source.reported_conversions
                                GROUP.reported_conversion_value = source.reported_conversion_value

                                GROUP.stats = source.stats
                                GROUP.data = source.data
                                GROUP.account_id = source.account_id
                                GROUP.account_name = source.account_name
                                GROUP.campaign = source.campaign

                                RESULTS.push( GROUP )
                            }else{

                                RESULTS.forEach((group)=>{
                                    if( group.external_id == source.adset.id ){
                                        group.clicks += source.clicks
                                        group.impressions += source.impressions
                                        group.ad_spent += source.ad_spent
                                        group.revenue += parseFloat( source.revenue )
                                        if( source.reported_conversion_value ){
                                            group.reported_conversion_value += parseFloat( source.reported_conversion_value )
                                        }
                                        if( source.reported_conversions ){
                                            group.reported_conversions += parseFloat( source.reported_conversions )
                                        }    
                                        //source.orders.forEach((order)=>{ group.orders.push(order) })
                                        if( source.orders.length > 0 ){
                                            let orders = group.orders.concat(source.orders)
                                            group.orders = orders
                                            //source.orders.forEach((order)=>{ group.orders.push(order) })
                                        }

                                        //console.log("Found")
                                        //console.log(group)

                                    }
                                })

                            }

                        }//end else group by adset

                    }
                    else{

                        if( this.groupBy.value == 'ad' || this.groupBy == null ){
                            RESULTS.push( source )
                        }else{

                            let found = RESULTS.find(el => el.external_id === source.origin )
                            if( found == undefined ){
                                let GROUP = { name: source.origin, external_id: source.origin, origin: source.origin, tag: this.nameToTag(source.origin, '@'), revenue: 0, clicks:0, ad_spent: 0, orders: source.orders }
                                //GROUP.orders = source.orders
                                GROUP.clicks = source.clicks
                                GROUP.impressions = source.impressions
                                GROUP.ad_spent = source.ad_spent
                                GROUP.revenue = source.revenue
                                GROUP.reported_conversions = source.reported_conversions
                                GROUP.reported_conversion_value = source.reported_conversion_value

                                GROUP.data = source.data
                                GROUP.stats = source.stats
                                GROUP.account_id = source.account_id
                                GROUP.account_name = source.account_name

                                //console.log("Created")
                                //console.log(GROUP)
                                RESULTS.push( GROUP )
                            }else{

                                RESULTS.forEach((group)=>{
                                    if( group.external_id == source.origin ){
                                        group.clicks += source.clicks
                                        group.impressions += source.impressions
                                        group.ad_spent += source.ad_spent
                                        group.revenue += parseFloat( source.revenue )
                                        if( source.reported_conversion_value ){
                                            group.reported_conversion_value += parseFloat( source.reported_conversion_value )
                                        }
                                        if( source.reported_conversions ){
                                            group.reported_conversions += parseFloat( source.reported_conversions )
                                        }    
                                        if( source.orders.length > 0 ){
                                            let orders = group.orders.concat(source.orders)
                                            group.orders = orders
                                            //source.orders.forEach((order)=>{ group.orders.push(order) })
                                        }
                                    }
                                })

                            }

                        }//end else group by account
                    }

                })
                //GROUP RESULTS
                
                //console.log(RESULTS)
                this.RESULTS = []
                this.RESULTS = RESULTS
            }else{
                this.RESULTS = this.SOURCES
            }
                
            
            //this.SOURCES = []
            //this.SOURCES = FILTERED_SOURCES
            
            this.RESULTS.sort(function(a,b){
                //console.log(a + " - "+ b)
                if( a.sort != false && b.sort != false ){
                    return b.revenue - a.revenue
                }
                
            })
            
            /*
            this.SOURCES.sort(function(a,b){
                //console.log(a + " - "+ b)
                if( a.sort != false && b.sort != false ){
                    return b.revenue - a.revenue
                }
                
            })
            */
            
            //setTimeout(function(){ this.dataLoaded = true }.bind(this), 100 );
            this.dataLoaded = true
            
        },
        
        filterResults(){
            
            let defaultValue = 'ATLASS_DEFAULT'
            let value = defaultValue+",MAILCHIMP"
            
            //this.$set(this.sourceColumns[0].filterOptions, 'filterValue', 'MAILCHIMP');
            
            //this.columnFilterFn
            
        },

        columnFilterFn: function(data, filterString) {
            //console.log(data)
            //console.log( filterString )
            //var x = parseInt(filterString)
            //return data >= x - 5 && data <= x + 5;
            if( data == 'ATLASS_DEFAULT' || data == filterString ){
                return data
            }
        },

        capitalizeFirstLetter(string) {
          return string.charAt(0).toUpperCase() + string.slice(1);
        },
        nameToTag: function(name, symbol = "$"){
            
            name = name.toLowerCase()
            let tag = name.replace(/\s/g, "-");
            tag = symbol + tag;
            
            return tag;
        },
        tagToName: function(tag){
                        
            let name = tag.replace(/[^a-zA-Z0-9- ]/g, "");
            tag = name.replace(/\s/g, "-");
            name = tag.replace(/-/g, " ")
            name = this.capitalizeFirstLetter( name )
            return name
        },
        
        //TABLE DISPLAY
        calculateLTV( data ){
            
            let LTV = {
                AVG_PURCHASE_VALUE: "-",
                AVG_PURCHASE_FREQ_RATE: "-",
                CUSTOMER_VALUE: "-",
                CLTV: "-",
            }
            
            let periodDiff = this.$moment(this.period[1], 'D MMM YYYY' ).unix() - this.$moment(this.period[0], 'D MMM YYYY' ).unix()
            
            //console.log( periodDiff / ( 60*60*24 ) )
            //if( ( periodDiff ) >= ( 60*60*24*14 ) ){
            if( ( periodDiff ) >= ( 60*60*24 ) ){
                LTV = helper.calculateLTV( data, this.period[0], this.period[1] )
                if( LTV.CLTV != NaN ){
                    LTV.CLTV = this.Numberformatter( LTV.CLTV, 'number' )
                }else{
                    //LTV.CLTV = "-"
                }
                this.LTV = LTV      
            }
             
            //console.log(LTV)
            //this.LTV = LTV.CLTV
            return LTV
            
        },
        
        countArray(array){
            array = array.orders
            return array.length
        },
        returnTag(a){
            if( a.tag != 'unattributed' ){
                return a.tag
            }else{
                return ''
            }
        },
        returnName(a){
            return a.firstname + " " + a.lastname;
        },
        return_price_column(a){
            //console.log(a)
            //return "$"+ a.toFixed(2)
            return this.Numberformatter( a, 'number' )
        },
        returnDate(a){
            return this.$moment.unix(a.datetime).format( 'MMM D, HH:mm' )
        },
        return_origin_column(a){
            if( a.origin ){
                return a.origin
            }else{
                return ""
            }
        },
        return_adspent_column(value){
            if( value || value == 0 ){
                value = parseFloat(value)
                return this.Numberformatter( value, 'number' )
            }else{
                return '-'
            }
        },
        return_clicks_column(a){
            //console.log( a.name + " - " + a.clicks )
            
            if( a.clicks || a.clicks == 0 ){
                return a.clicks
            }else{
                return "-"
            }
        },
        return_ROI_column(a){
            if( a.ad_spent ){
                if( a.ad_spent == 0 ){
                    //console.log(a)
                }
                //https://support.google.com/google-ads/answer/14090?hl=en#:~:text=To%20calculate%20ROI%2C%20take%20the,)%20%2F%20Cost%20of%20goods%20sold.
                //ROI = (Revenue - Cost of goods sold) / Cost of goods sold
                //
                //let ROI = ( a.revenue / a.ad_spent ) * 100
                //let ROI = ( a.revenue - a.ad_spent ) / a.ad_spent
                
                //ROI=(Gains-Costs)/Costs ×100
                let ROI = parseFloat(a.revenue)/parseFloat(a.ad_spent) * 100
                //console.log(ROI)
                return this.Numberformatter( ROI, 'percentage', true )
                
            }else{
                return "-"
            }
        },
        
        return_revenue_column(a){
            //console.log(a)
            return this.Numberformatter( a.revenue, 'number' )
            
        },
        
        Numberformatter(value, type, html ) {
            
            return helper.Numberformatter(value, type, html );
            
        },
        
        return_PROFIT_column(a){
            if( a.ad_spent || a.ad_spent == 0 ){
                let PROFIT = a.revenue - a.ad_spent
                return this.Numberformatter( PROFIT, 'number', true )
            }else{
                return "-"
            }
        },
        return_ROAS_column(a){
            if( a.ad_spent ){
                let ROAS = ( a.revenue / a.ad_spent )
                return this.Numberformatter( ROAS, 'plain-number', true )
            }else{
                return "-"
            }
        },
        return_AVG_QUANTITY_column(a){
            //console.log(a)
            if( a.orders.length > 0 ){
                let SUM_QUANTITY = 0
                a.orders.forEach((c)=>{
                    if( c.orderItems ){
                        SUM_QUANTITY += c.orderItems.length
                    }else{
                        SUM_QUANTITY += 1
                    }
                    
                })
                return this.Numberformatter( SUM_QUANTITY / a.orders.length, 'plain-number' )
            }else{
                return "-"
            }
        },
        return_CPC_column(a){
            if( a.ad_spent ){
                let value = ( a.ad_spent / a.clicks )
                if( a.ad_spent == 0 || a.clicks == 0 ){
                    value = 0
                }
                return this.Numberformatter( value, 'number' )
            }else{
                return "-"
            }
        },
        return_CTR_column(a){
            if( a.clicks && a.impressions ){
                let value = ( a.clicks / a.impressions ) * 100
                return this.Numberformatter( value, 'percentage' )
            }else{
                return "-"
            }
        },
        return_CPA_column(a){
            if( a.ad_spent ){
                let value = ( a.ad_spent / a.orders.length )
                if( a.orders.length ==  0 ){
                    value = 0
                }
                return this.Numberformatter( value, 'number' )
            }else{
                return "-"
            }
        },
        return_CR_column(a){
            if( a.clicks > 0 && a.orders.length > 0 ){
                let value = ( a.orders.length  / a.clicks ) * 100
                return this.Numberformatter( value, 'percentage' )
            }else{
                return "-"
            }
        },
        
        //MODAL AND NAVIGATION
        openCampaign(params){
            //console.log(params)
            if( params.row.open != false ){
                this.fModalOpen( 'source', params.row );
            }
                
        },
        User(params){
            //console.log(params)
            this.fModalOpen( 'lead', params.row );
        },
        fModalOpen( target, data ){
            if( target == 'source' ){
                this.modalData = data.orders
            }else{
                this.selectedLead = data
            }
            this.modalState = true
        },
        
        //filter functions
        showEmptySources( source ){
            if( !this.showEmpty ){
                if( source.orders.length > 0 ){ return true }
                else{
                    return false
                }
            }else{
                return true
            }
        },
        
        testChange(){
            console.log(this.selected_sourcesOrigin)
        },
      
        resourcesLink( query ){
            //console.log( process.env.ROOT_DOMAIN_RESOURCES )
            //https://theatlass.com/help/docs/learn-about-attribution-modes/
            return process.env.ROOT_DOMAIN_RESOURCES + '/'+query
        },
        
        switchChart(target){
            
            console.log(target)
            this.dataLoaded = false
            this.selectedChart = target
            setTimeout(function(){ this.dataLoaded = true }.bind(this), 250 );
        },
        
        uniqueItemsInArray(data, identifier ){
            return helper.uniqueItems( data, identifier )
        }
        
    },
    watch:{
        parentPeriod(){
            this.init_period()
        }
    },
    computed:{
        filteredRows(){
            
            this.dataLoaded = false
            
            let result = this.rows.filter(item => {
                //let props = (this.search && this.column) ? [item[this.column]] : Object.values(item)
                //return props.some(prop => !this.search || ((typeof prop === 'string') ? prop.includes(this.search) : prop.toString(10).includes(this.search)))
                //console.log(item)
                let found = false

                if( ( this.selected_sourcesOrigin.includes( item.origin ) || item.origin == 'ATLASS_DEFAULT'  )&& this.showEmptySources(item) ){
                    found = true
                }
                
                
                this.dataLoaded = true
                if( found ){ return item }
                
            })
            
            //console.log(result)
            
            return this.SOURCES
            
        },
        filteredSources(){
            
            this.dataLoaded = false
            
            return this.RESULTS.filter(item => {
                //let props = (this.search && this.column) ? [item[this.column]] : Object.values(item)
                //return props.some(prop => !this.search || ((typeof prop === 'string') ? prop.includes(this.search) : prop.toString(10).includes(this.search)))
                //console.log(item)
                let found = false

                //if( ( this.selected_sourcesOrigin.includes( item.origin ) || item.origin == 'ATLASS_DEFAULT'  ) && this.showEmptySources(item) ){
                if( this.showEmptySources(item) && 
                  
                   ( this.selected_sourcesOrigin.value == null || (this.selected_sourcesOrigin != null && this.selected_sourcesOrigin.value == item.origin ) || item.origin == 'ATLASS_DEFAULT' )
                   
                   
                  
                  ){
                    found = true
                }
                
                
                this.dataLoaded = true
                if( found ){ return item }
                
            })
            
            //console.log(result)
            
            //return this.SOURCES
            
        }
        
    },
}
</script>


<style lang="scss" >
    
     @import '@/assets/css/variables.scss';

    .reset-filter{
        position: absolute;
        right:0;
        line-height: 50px;
        font-size: 18px;
        margin-right: 9px;
        margin-top: 9px;
        color: #777;
        z-index: 999;
        cursor: pointer
    }
    
    .analyze-page .custom-switch{
        line-height: 23px;
        margin-left: 5px;
        display: inline-block;
        background-color: transparent !important;
        border-style: none !important;
        cursor: pointer;
    }
    
    .analyze-page .custom-switch:focus, 
    .analyze-page .custom-switch:active, 
    .analyze-page .custom-switch, 
    .analyze-page .custom-switch div, 
    .analyze-page .custom-switch input, 
    .analyze-page .custom-switch label, 
    .analyze-page .custom-switch *{
        outline: none!important;
        box-shadow: none!important;
        outline-color: transparent;
        outline: thin dotted;
        outline: 5px auto -webkit-focus-ring-color;
        outline-offset: -2px;
        
    }
    
    .analyze-page .custom-control-input:checked ~ .custom-control-label:before{
        background-color: #fff!important;
        border: $grayMedium solid 1px!important;
    }
    
    .analyze-page .custom-switch .custom-control-label::after{
        background-color: $grayDark!important;
    }
    
    /*DATETIME PICKER*/
    .mx-datepicker-sidebar{
        float: right;
        width: 105px;
    }
    .mx-datepicker-sidebar .mx-btn{
        font-size: 13px;
        font-weight: normal;
    }
    .mx-datepicker-sidebar + .mx-datepicker-content{
        margin-left: 0px;
        margin-right: 105px;
        border-right: 1px solid #e8e8e8;
    }
    
    /**/
    .reported-stats-span{
        font-size: 0.85rem;
        color: $grayMedium;
    }
    .reported-stats-span svg{
        
    }
</style>


// WEBPACK FOOTER //
// src/templates/analyze/Attribution.vue